var map = {
	"./CurrencyManagement": 1053,
	"./CurrencyManagement.js": 1053,
	"./TRM": 1054,
	"./TRM.js": 1054,
	"./TRM/filter": 175,
	"./TRM/filter.js": 175,
	"./TRM/table": 176,
	"./TRM/table.js": 176,
	"./accounting/accounts": 1055,
	"./accounting/accounts.js": 1055,
	"./accounting/accounts/filter": 177,
	"./accounting/accounts/filter.js": 177,
	"./accounting/accounts/table": 178,
	"./accounting/accounts/table.js": 178,
	"./accounting/area": 1056,
	"./accounting/area.js": 1056,
	"./accounting/area/filter": 1009,
	"./accounting/area/filter.js": 1009,
	"./accounting/area/table": 179,
	"./accounting/area/table.js": 179,
	"./accounting/area_copy": 1057,
	"./accounting/area_copy.js": 1057,
	"./accounting/closingDayReport": 1058,
	"./accounting/closingDayReport.js": 1058,
	"./accounting/closingDayReport/filter": 180,
	"./accounting/closingDayReport/filter.js": 180,
	"./accounting/closingDayReport/table": 181,
	"./accounting/closingDayReport/table.js": 181,
	"./accounting/concepts": 1059,
	"./accounting/concepts.js": 1059,
	"./accounting/concepts/filter": 182,
	"./accounting/concepts/filter.js": 182,
	"./accounting/concepts/table": 183,
	"./accounting/concepts/table.js": 183,
	"./accounting/costCenter": 1060,
	"./accounting/costCenter.js": 1060,
	"./accounting/costCenter/filter": 184,
	"./accounting/costCenter/filter.js": 184,
	"./accounting/costCenter/table": 185,
	"./accounting/costCenter/table.js": 185,
	"./accounting/employees": 1061,
	"./accounting/employees.js": 1061,
	"./accounting/employees/filter": 1010,
	"./accounting/employees/filter.js": 1010,
	"./accounting/employees/table": 186,
	"./accounting/employees/table.js": 186,
	"./accounting/expenses": 1062,
	"./accounting/expenses.js": 1062,
	"./accounting/expenses/filter": 187,
	"./accounting/expenses/filter.js": 187,
	"./accounting/expenses/table": 188,
	"./accounting/expenses/table.js": 188,
	"./accounting/incomes": 1063,
	"./accounting/incomes.js": 1063,
	"./accounting/incomes/filter": 189,
	"./accounting/incomes/filter.js": 189,
	"./accounting/incomes/table": 190,
	"./accounting/incomes/table.js": 190,
	"./accounting/position": 1064,
	"./accounting/position.js": 1064,
	"./accounting/position/filter": 1011,
	"./accounting/position/filter.js": 1011,
	"./accounting/position/table": 191,
	"./accounting/position/table.js": 191,
	"./accounting/productsThirdBetShop": 1065,
	"./accounting/productsThirdBetShop.js": 1065,
	"./accounting/productsThirdBetShop/filter": 1012,
	"./accounting/productsThirdBetShop/filter.js": 1012,
	"./accounting/productsThirdBetShop/table": 192,
	"./accounting/productsThirdBetShop/table.js": 192,
	"./accounting/productsThirdByBetShop": 1066,
	"./accounting/productsThirdByBetShop.js": 1066,
	"./accounting/productsThirdByBetShop/filter": 193,
	"./accounting/productsThirdByBetShop/filter.js": 193,
	"./accounting/productsThirdByBetShop/table": 194,
	"./accounting/productsThirdByBetShop/table.js": 194,
	"./accounting/productsThirdQuota": 1067,
	"./accounting/productsThirdQuota.js": 1067,
	"./accounting/productsThirdQuota/filter": 195,
	"./accounting/productsThirdQuota/filter.js": 195,
	"./accounting/productsThirdQuota/table": 196,
	"./accounting/productsThirdQuota/table.js": 196,
	"./accounting/providers": 1068,
	"./accounting/providers.js": 1068,
	"./accounting/providers/filter": 1013,
	"./accounting/providers/filter.js": 1013,
	"./accounting/providers/table": 197,
	"./accounting/providers/table.js": 197,
	"./accounting/providers/tableProductsThirdBetShop": 1069,
	"./accounting/providers/tableProductsThirdBetShop.js": 1069,
	"./accounting/providers_copy": 1070,
	"./accounting/providers_copy.js": 1070,
	"./accounting/squareDayReport": 1071,
	"./accounting/squareDayReport.js": 1071,
	"./accounting/squareDayReport/filter": 198,
	"./accounting/squareDayReport/filter.js": 198,
	"./accounting/squareDayReport/table": 199,
	"./accounting/squareDayReport/table.js": 199,
	"./accounting/squareDayReport2": 1072,
	"./accounting/squareDayReport2.js": 1072,
	"./accounting/squareDayReport2/filter": 200,
	"./accounting/squareDayReport2/filter.js": 200,
	"./accounting/squareDayReport2/table": 201,
	"./accounting/squareDayReport2/table.js": 201,
	"./accounting/typeCenterPosition": 1073,
	"./accounting/typeCenterPosition.js": 1073,
	"./accounting/typeDocument": 1074,
	"./accounting/typeDocument.js": 1074,
	"./accounting/typeDocument/filter": 203,
	"./accounting/typeDocument/filter.js": 203,
	"./accounting/typeDocument/table": 204,
	"./accounting/typeDocument/table.js": 204,
	"./accounting/types/filter": 1014,
	"./accounting/types/filter.js": 1014,
	"./accounting/types/table": 202,
	"./accounting/types/table.js": 202,
	"./activateRegistration": 1075,
	"./activateRegistration.js": 1075,
	"./activeProviders": 1076,
	"./activeProviders.js": 1076,
	"./addAdminUserManagement": 1077,
	"./addAdminUserManagement.js": 1077,
	"./addAgentListManagement": 1078,
	"./addAgentListManagement.js": 1078,
	"./addBetShopManagement": 1079,
	"./addBetShopManagement.js": 1079,
	"./adminUser": 1080,
	"./adminUser.js": 1080,
	"./adminUserManagement": 1081,
	"./adminUserManagement.js": 1081,
	"./affiliatesBetShop": 1082,
	"./affiliatesBetShop.js": 1082,
	"./agent/addInformationAgentList": 1083,
	"./agent/addInformationAgentList.js": 1083,
	"./agent/age": 1084,
	"./agent/age.js": 1084,
	"./agent/agent-list/detailsAgentList": 213,
	"./agent/agent-list/detailsAgentList.js": 213,
	"./agent/agent-list/filterAgentList": 214,
	"./agent/agent-list/filterAgentList.js": 214,
	"./agent/agent-list/recordAgentList": 215,
	"./agent/agent-list/recordAgentList.js": 215,
	"./agent/agent-list/recordTableAgentList": 1015,
	"./agent/agent-list/recordTableAgentList.js": 1015,
	"./agent/agent-list/tableAgentList": 216,
	"./agent/agent-list/tableAgentList.js": 216,
	"./agent/agent-retraction/PagoPremio": 217,
	"./agent/agent-retraction/PagoPremio.js": 217,
	"./agent/agent-retraction/search": 218,
	"./agent/agent-retraction/search.js": 218,
	"./agent/agent-retraction/transfers": 219,
	"./agent/agent-retraction/transfers.js": 219,
	"./agent/agent-retraction/transfers1": 220,
	"./agent/agent-retraction/transfers1.js": 220,
	"./agent/agent-transfers/PagoPremio": 221,
	"./agent/agent-transfers/PagoPremio.js": 221,
	"./agent/agent-transfers/search": 222,
	"./agent/agent-transfers/search.js": 222,
	"./agent/agent-transfers/transfers": 223,
	"./agent/agent-transfers/transfers.js": 223,
	"./agent/agent-transfers/transfers1": 224,
	"./agent/agent-transfers/transfers1.js": 224,
	"./agent/agent-tree/details": 1016,
	"./agent/agent-tree/details.js": 1016,
	"./agent/agent-tree/filter": 225,
	"./agent/agent-tree/filter.js": 225,
	"./agent/agent-tree/record": 131,
	"./agent/agent-tree/record.js": 131,
	"./agent/agent-tree/recordTableAgentList": 226,
	"./agent/agent-tree/recordTableAgentList.js": 226,
	"./agent/agent-tree/table": 227,
	"./agent/agent-tree/table.js": 227,
	"./agent/bonusReportAgentList": 1085,
	"./agent/bonusReportAgentList.js": 1085,
	"./agent/casinoGamesReportAgentList": 1086,
	"./agent/casinoGamesReportAgentList.js": 1086,
	"./agent/comissions": 1087,
	"./agent/comissions.js": 1087,
	"./agent/comissions/autoexclusionUsers": 1088,
	"./agent/comissions/autoexclusionUsers.js": 1088,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1089,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1089,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1090,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1090,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1091,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1091,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1092,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1092,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1093,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1093,
	"./agent/comissions/betsReport/detailsReport": 1094,
	"./agent/comissions/betsReport/detailsReport.js": 1094,
	"./agent/comissions/betsReport/filterReport": 1095,
	"./agent/comissions/betsReport/filterReport.js": 1095,
	"./agent/comissions/betsReport/recordReport": 1096,
	"./agent/comissions/betsReport/recordReport.js": 1096,
	"./agent/comissions/betsReport/recordTableReport": 1097,
	"./agent/comissions/betsReport/recordTableReport.js": 1097,
	"./agent/comissions/betsReport/recordTableTransReport": 1098,
	"./agent/comissions/betsReport/recordTableTransReport.js": 1098,
	"./agent/comissions/betsReport/recordTransReport": 1099,
	"./agent/comissions/betsReport/recordTransReport.js": 1099,
	"./agent/comissions/betsReport/tableReport": 1100,
	"./agent/comissions/betsReport/tableReport.js": 1100,
	"./agent/comissions/betsReportBetShop": 1101,
	"./agent/comissions/betsReportBetShop.js": 1101,
	"./agent/comissions/bonusReport/detailsBonusReport": 1102,
	"./agent/comissions/bonusReport/detailsBonusReport.js": 1102,
	"./agent/comissions/bonusReport/filterBonusReport": 1103,
	"./agent/comissions/bonusReport/filterBonusReport.js": 1103,
	"./agent/comissions/bonusReport/recordBonusReport": 1104,
	"./agent/comissions/bonusReport/recordBonusReport.js": 1104,
	"./agent/comissions/bonusReport/recordTableBonusReport": 1105,
	"./agent/comissions/bonusReport/recordTableBonusReport.js": 1105,
	"./agent/comissions/bonusReport/tableBonusReport": 1106,
	"./agent/comissions/bonusReport/tableBonusReport.js": 1106,
	"./agent/comissions/casinoReport/detailsCasinoReport": 1107,
	"./agent/comissions/casinoReport/detailsCasinoReport.js": 1107,
	"./agent/comissions/casinoReport/filterCasinoReport": 1108,
	"./agent/comissions/casinoReport/filterCasinoReport.js": 1108,
	"./agent/comissions/casinoReport/recordCasinoReport": 1109,
	"./agent/comissions/casinoReport/recordCasinoReport.js": 1109,
	"./agent/comissions/casinoReport/recordTableCasinoReport": 1110,
	"./agent/comissions/casinoReport/recordTableCasinoReport.js": 1110,
	"./agent/comissions/casinoReport/tableCasinoReport": 1111,
	"./agent/comissions/casinoReport/tableCasinoReport.js": 1111,
	"./agent/comissions/casinoReport2/detailsCasinoReport": 1112,
	"./agent/comissions/casinoReport2/detailsCasinoReport.js": 1112,
	"./agent/comissions/casinoReport2/filterCasinoReport": 1113,
	"./agent/comissions/casinoReport2/filterCasinoReport.js": 1113,
	"./agent/comissions/casinoReport2/recordCasinoReport": 1114,
	"./agent/comissions/casinoReport2/recordCasinoReport.js": 1114,
	"./agent/comissions/casinoReport2/recordTableCasinoReport": 1115,
	"./agent/comissions/casinoReport2/recordTableCasinoReport.js": 1115,
	"./agent/comissions/casinoReport2/tableCasinoReport": 1116,
	"./agent/comissions/casinoReport2/tableCasinoReport.js": 1116,
	"./agent/comissions/comissions": 1117,
	"./agent/comissions/comissions.js": 1117,
	"./agent/comissions/comissions/table": 236,
	"./agent/comissions/comissions/table.js": 236,
	"./agent/comissions/comissionsReportBetShop": 1118,
	"./agent/comissions/comissionsReportBetShop.js": 1118,
	"./agent/comissions/comissionsReportBetShopDetail": 1119,
	"./agent/comissions/comissionsReportBetShopDetail.js": 1119,
	"./agent/comissions/comissions_report/detailsDepositReports": 1120,
	"./agent/comissions/comissions_report/detailsDepositReports.js": 1120,
	"./agent/comissions/comissions_report/filter": 237,
	"./agent/comissions/comissions_report/filter.js": 237,
	"./agent/comissions/comissions_report/recordDepositReports": 1121,
	"./agent/comissions/comissions_report/recordDepositReports.js": 1121,
	"./agent/comissions/comissions_report/recordTableDepositReports": 1122,
	"./agent/comissions/comissions_report/recordTableDepositReports.js": 1122,
	"./agent/comissions/comissions_report/table": 238,
	"./agent/comissions/comissions_report/table.js": 238,
	"./agent/comissions/comissions_report_detail/detailsDepositReports": 1123,
	"./agent/comissions/comissions_report_detail/detailsDepositReports.js": 1123,
	"./agent/comissions/comissions_report_detail/filter": 239,
	"./agent/comissions/comissions_report_detail/filter.js": 239,
	"./agent/comissions/comissions_report_detail/recordDepositReports": 1124,
	"./agent/comissions/comissions_report_detail/recordDepositReports.js": 1124,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports": 1125,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports.js": 1125,
	"./agent/comissions/comissions_report_detail/table": 240,
	"./agent/comissions/comissions_report_detail/table.js": 240,
	"./agent/comissions/expenses": 1126,
	"./agent/comissions/expenses.js": 1126,
	"./agent/comissions/expenses/filter": 1127,
	"./agent/comissions/expenses/filter.js": 1127,
	"./agent/comissions/expenses/table": 1128,
	"./agent/comissions/expenses/table.js": 1128,
	"./agent/comissions/flujocaja/detailsFlujoCaja": 1129,
	"./agent/comissions/flujocaja/detailsFlujoCaja.js": 1129,
	"./agent/comissions/flujocaja/filterFlujoCaja": 1130,
	"./agent/comissions/flujocaja/filterFlujoCaja.js": 1130,
	"./agent/comissions/flujocaja/recordFlujoCaja": 1131,
	"./agent/comissions/flujocaja/recordFlujoCaja.js": 1131,
	"./agent/comissions/flujocaja/recordTableFlujoCaja": 1132,
	"./agent/comissions/flujocaja/recordTableFlujoCaja.js": 1132,
	"./agent/comissions/flujocaja/tableFlujoCaja": 1133,
	"./agent/comissions/flujocaja/tableFlujoCaja.js": 1133,
	"./agent/comissions/incomes": 1134,
	"./agent/comissions/incomes.js": 1134,
	"./agent/comissions/incomes/filter": 1135,
	"./agent/comissions/incomes/filter.js": 1135,
	"./agent/comissions/incomes/table": 1136,
	"./agent/comissions/incomes/table.js": 1136,
	"./agent/comissions/productsThird": 1137,
	"./agent/comissions/productsThird.js": 1137,
	"./agent/comissions/productsThird/filter": 1138,
	"./agent/comissions/productsThird/filter.js": 1138,
	"./agent/comissions/productsThird/table": 1139,
	"./agent/comissions/productsThird/table.js": 1139,
	"./agent/comissions/promotionalCodes": 1140,
	"./agent/comissions/promotionalCodes.js": 1140,
	"./agent/comissions/promotionalCodes/filter": 1141,
	"./agent/comissions/promotionalCodes/filter.js": 1141,
	"./agent/comissions/promotionalCodes/table": 1142,
	"./agent/comissions/promotionalCodes/table.js": 1142,
	"./agent/comissions/withdrawalRequests": 1143,
	"./agent/comissions/withdrawalRequests.js": 1143,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests": 243,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 243,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest": 241,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest.js": 241,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1144,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1144,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest": 244,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest.js": 244,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest": 242,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest.js": 242,
	"./agent/configuration/changePassword": 1145,
	"./agent/configuration/changePassword.js": 1145,
	"./agent/configuration/changePassword/changePasswordView": 60,
	"./agent/configuration/changePassword/changePasswordView.js": 60,
	"./agent/configuration/generateToken": 1146,
	"./agent/configuration/generateToken.js": 1146,
	"./agent/configuration/generateToken/filter": 61,
	"./agent/configuration/generateToken/filter.js": 61,
	"./agent/configuration/generateToken/table": 62,
	"./agent/configuration/generateToken/table.js": 62,
	"./agent/configuration/qrgoogle": 1147,
	"./agent/configuration/qrgoogle.js": 1147,
	"./agent/configuration/securityChanges": 1148,
	"./agent/configuration/securityChanges.js": 1148,
	"./agent/configuration/securityChanges/filter": 47,
	"./agent/configuration/securityChanges/filter.js": 47,
	"./agent/configuration/securityChanges/table": 38,
	"./agent/configuration/securityChanges/table.js": 38,
	"./agent/configurationAgentList": 1149,
	"./agent/configurationAgentList.js": 1149,
	"./agent/depositReportAgentList": 1150,
	"./agent/depositReportAgentList.js": 1150,
	"./agent/financescustomerAgentList": 1151,
	"./agent/financescustomerAgentList.js": 1151,
	"./agent/financial/comisiones": 1152,
	"./agent/financial/comisiones.js": 1152,
	"./agent/financial/comisiones/table": 247,
	"./agent/financial/comisiones/table.js": 247,
	"./agent/financial/informationFinancialAgentList": 1153,
	"./agent/financial/informationFinancialAgentList.js": 1153,
	"./agent/financial/withdrawalRequestsAgentList": 1154,
	"./agent/financial/withdrawalRequestsAgentList.js": 1154,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList": 132,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList.js": 132,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList": 248,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList.js": 248,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList": 1155,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList.js": 1155,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList": 133,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList.js": 133,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList": 249,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList.js": 249,
	"./agent/flujoCajaAgentList": 1156,
	"./agent/flujoCajaAgentList.js": 1156,
	"./agent/flujoCajaHijosAgentList": 1157,
	"./agent/flujoCajaHijosAgentList.js": 1157,
	"./agent/geo": 1158,
	"./agent/geo.js": 1158,
	"./agent/informationAgentList": 1159,
	"./agent/informationAgentList.js": 1159,
	"./agent/informeRed/details": 1160,
	"./agent/informeRed/details.js": 1160,
	"./agent/informeRed/filter": 256,
	"./agent/informeRed/filter.js": 256,
	"./agent/informeRed/record": 1161,
	"./agent/informeRed/record.js": 1161,
	"./agent/informeRed/recordTable": 1162,
	"./agent/informeRed/recordTable.js": 1162,
	"./agent/informeRed/table": 257,
	"./agent/informeRed/table.js": 257,
	"./agent/money": 1163,
	"./agent/money.js": 1163,
	"./agent/paymenthistory": 1164,
	"./agent/paymenthistory.js": 1164,
	"./agent/positions": 1165,
	"./agent/positions.js": 1165,
	"./agent/reports/autoexclusionUsers": 1166,
	"./agent/reports/autoexclusionUsers.js": 1166,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1167,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1167,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers": 1168,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1168,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers": 1169,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1169,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1170,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1170,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers": 1171,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1171,
	"./agent/reports/balanceTransactionReport": 1172,
	"./agent/reports/balanceTransactionReport.js": 1172,
	"./agent/reports/balanceTransactionReport/filter": 258,
	"./agent/reports/balanceTransactionReport/filter.js": 258,
	"./agent/reports/balanceTransactionReport/table": 259,
	"./agent/reports/balanceTransactionReport/table.js": 259,
	"./agent/reports/betsReport/detailsReport": 1173,
	"./agent/reports/betsReport/detailsReport.js": 1173,
	"./agent/reports/betsReport/filterReport": 260,
	"./agent/reports/betsReport/filterReport.js": 260,
	"./agent/reports/betsReport/recordReport": 134,
	"./agent/reports/betsReport/recordReport.js": 134,
	"./agent/reports/betsReport/recordTableReport": 1174,
	"./agent/reports/betsReport/recordTableReport.js": 1174,
	"./agent/reports/betsReport/recordTableTransReport": 1175,
	"./agent/reports/betsReport/recordTableTransReport.js": 1175,
	"./agent/reports/betsReport/recordTransReport": 135,
	"./agent/reports/betsReport/recordTransReport.js": 135,
	"./agent/reports/betsReport/tableReport": 261,
	"./agent/reports/betsReport/tableReport.js": 261,
	"./agent/reports/betsReportAgentList": 1176,
	"./agent/reports/betsReportAgentList.js": 1176,
	"./agent/reports/bonusReport/detailsBonusReport": 230,
	"./agent/reports/bonusReport/detailsBonusReport.js": 230,
	"./agent/reports/bonusReport/filterBonusReport": 228,
	"./agent/reports/bonusReport/filterBonusReport.js": 228,
	"./agent/reports/bonusReport/recordBonusReport": 231,
	"./agent/reports/bonusReport/recordBonusReport.js": 231,
	"./agent/reports/bonusReport/recordTableBonusReport": 1177,
	"./agent/reports/bonusReport/recordTableBonusReport.js": 1177,
	"./agent/reports/bonusReport/tableBonusReport": 229,
	"./agent/reports/bonusReport/tableBonusReport.js": 229,
	"./agent/reports/casinoReport/detailsCasinoReport": 234,
	"./agent/reports/casinoReport/detailsCasinoReport.js": 234,
	"./agent/reports/casinoReport/filterCasinoReport": 232,
	"./agent/reports/casinoReport/filterCasinoReport.js": 232,
	"./agent/reports/casinoReport/recordCasinoReport": 235,
	"./agent/reports/casinoReport/recordCasinoReport.js": 235,
	"./agent/reports/casinoReport/recordTableCasinoReport": 1178,
	"./agent/reports/casinoReport/recordTableCasinoReport.js": 1178,
	"./agent/reports/casinoReport/tableCasinoReport": 233,
	"./agent/reports/casinoReport/tableCasinoReport.js": 233,
	"./agent/reports/casinoReport2/detailsCasinoReport": 1179,
	"./agent/reports/casinoReport2/detailsCasinoReport.js": 1179,
	"./agent/reports/casinoReport2/filterCasinoReport": 1180,
	"./agent/reports/casinoReport2/filterCasinoReport.js": 1180,
	"./agent/reports/casinoReport2/recordCasinoReport": 1181,
	"./agent/reports/casinoReport2/recordCasinoReport.js": 1181,
	"./agent/reports/casinoReport2/recordTableCasinoReport": 1182,
	"./agent/reports/casinoReport2/recordTableCasinoReport.js": 1182,
	"./agent/reports/casinoReport2/tableCasinoReport": 1183,
	"./agent/reports/casinoReport2/tableCasinoReport.js": 1183,
	"./agent/reports/deposit_report/detailsDepositReports": 1184,
	"./agent/reports/deposit_report/detailsDepositReports.js": 1184,
	"./agent/reports/deposit_report/filterDepositReports": 245,
	"./agent/reports/deposit_report/filterDepositReports.js": 245,
	"./agent/reports/deposit_report/recordDepositReports": 1185,
	"./agent/reports/deposit_report/recordDepositReports.js": 1185,
	"./agent/reports/deposit_report/recordTableDepositReports": 1186,
	"./agent/reports/deposit_report/recordTableDepositReports.js": 1186,
	"./agent/reports/deposit_report/tableDepositReports": 246,
	"./agent/reports/deposit_report/tableDepositReports.js": 246,
	"./agent/reports/flujocaja/detailsFlujoCaja": 1187,
	"./agent/reports/flujocaja/detailsFlujoCaja.js": 1187,
	"./agent/reports/flujocaja/filterFlujoCaja": 250,
	"./agent/reports/flujocaja/filterFlujoCaja.js": 250,
	"./agent/reports/flujocaja/recordFlujoCaja": 1188,
	"./agent/reports/flujocaja/recordFlujoCaja.js": 1188,
	"./agent/reports/flujocaja/recordTableFlujoCaja": 1189,
	"./agent/reports/flujocaja/recordTableFlujoCaja.js": 1189,
	"./agent/reports/flujocaja/tableFlujoCaja": 251,
	"./agent/reports/flujocaja/tableFlujoCaja.js": 251,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos": 254,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos.js": 254,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos": 252,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos.js": 252,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos": 255,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos.js": 255,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos": 1190,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos.js": 1190,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos": 253,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos.js": 253,
	"./agent/reports/managementReport": 1191,
	"./agent/reports/managementReport.js": 1191,
	"./agent/reports/managementReport/filterReports": 262,
	"./agent/reports/managementReport/filterReports.js": 262,
	"./agent/reports/managementReport/tableReports": 263,
	"./agent/reports/managementReport/tableReports.js": 263,
	"./agent/reports/marketing/filterReports": 264,
	"./agent/reports/marketing/filterReports.js": 264,
	"./agent/reports/marketing/tableReports": 265,
	"./agent/reports/marketing/tableReports.js": 265,
	"./agent/reports/marketingReport": 1192,
	"./agent/reports/marketingReport.js": 1192,
	"./agent/reports/promotionalCodes": 1193,
	"./agent/reports/promotionalCodes.js": 1193,
	"./agent/reports/promotionalCodes/filter": 266,
	"./agent/reports/promotionalCodes/filter.js": 266,
	"./agent/reports/promotionalCodes/table": 267,
	"./agent/reports/promotionalCodes/table.js": 267,
	"./agent/reports/quotaRetractionReport/filter": 268,
	"./agent/reports/quotaRetractionReport/filter.js": 268,
	"./agent/reports/quotaRetractionReport/table": 269,
	"./agent/reports/quotaRetractionReport/table.js": 269,
	"./agent/reports/quotaRetractionReportAgent": 1194,
	"./agent/reports/quotaRetractionReportAgent.js": 1194,
	"./agent/reports/transfersReport/filter": 270,
	"./agent/reports/transfersReport/filter.js": 270,
	"./agent/reports/transfersReport/table": 271,
	"./agent/reports/transfersReport/table.js": 271,
	"./agent/reports/trasnfersReport": 1195,
	"./agent/reports/trasnfersReport.js": 1195,
	"./agent/reports/userAfilliatesReport": 1196,
	"./agent/reports/userAfilliatesReport.js": 1196,
	"./agent/reports/user_affiliates/detailsReports": 274,
	"./agent/reports/user_affiliates/detailsReports.js": 274,
	"./agent/reports/user_affiliates/filterReports": 272,
	"./agent/reports/user_affiliates/filterReports.js": 272,
	"./agent/reports/user_affiliates/recordReports": 275,
	"./agent/reports/user_affiliates/recordReports.js": 275,
	"./agent/reports/user_affiliates/recordTableReports": 1197,
	"./agent/reports/user_affiliates/recordTableReports.js": 1197,
	"./agent/reports/user_affiliates/tableReports": 273,
	"./agent/reports/user_affiliates/tableReports.js": 273,
	"./agent/reportscustomerAgentList": 1198,
	"./agent/reportscustomerAgentList.js": 1198,
	"./agent/requestsAgent": 1199,
	"./agent/requestsAgent.js": 1199,
	"./agent/requestsAgent/filter": 276,
	"./agent/requestsAgent/filter.js": 276,
	"./agent/requestsAgent/table": 277,
	"./agent/requestsAgent/table.js": 277,
	"./agent/requirementsAgent": 1200,
	"./agent/requirementsAgent.js": 1200,
	"./agent/requirementsAgent/details": 280,
	"./agent/requirementsAgent/details.js": 280,
	"./agent/requirementsAgent/detailsFilter": 282,
	"./agent/requirementsAgent/detailsFilter.js": 282,
	"./agent/requirementsAgent/detailsTable": 281,
	"./agent/requirementsAgent/detailsTable.js": 281,
	"./agent/requirementsAgent/filter": 278,
	"./agent/requirementsAgent/filter.js": 278,
	"./agent/requirementsAgent/table": 279,
	"./agent/requirementsAgent/table.js": 279,
	"./agent/statistics/age": 283,
	"./agent/statistics/age.js": 283,
	"./agent/statistics/marketing": 284,
	"./agent/statistics/marketing.js": 284,
	"./agent/statistics/marketingvsregistros": 285,
	"./agent/statistics/marketingvsregistros.js": 285,
	"./agent/statistics/money": 286,
	"./agent/statistics/money.js": 286,
	"./agent/statisticsAgentList": 1201,
	"./agent/statisticsAgentList.js": 1201,
	"./agent/tags": 1202,
	"./agent/tags.js": 1202,
	"./agentList": 1203,
	"./agentList.js": 1203,
	"./agentListManagement": 1204,
	"./agentListManagement.js": 1204,
	"./agentRetraction": 1205,
	"./agentRetraction.js": 1205,
	"./agentTransfers": 1206,
	"./agentTransfers.js": 1206,
	"./agentsInform": 1207,
	"./agentsInform.js": 1207,
	"./agentsTree": 1208,
	"./agentsTree.js": 1208,
	"./alltactions": 287,
	"./alltactions.js": 287,
	"./approvalLogs": 1209,
	"./approvalLogs.js": 1209,
	"./approvalLogs2": 1210,
	"./approvalLogs2.js": 1210,
	"./approvalLogsBetShop": 1211,
	"./approvalLogsBetShop.js": 1211,
	"./assignmentQuotaMade": 1212,
	"./assignmentQuotaMade.js": 1212,
	"./assignmentQuotaR": 1213,
	"./assignmentQuotaR.js": 1213,
	"./autoexclusionUsers": 1214,
	"./autoexclusionUsers.js": 1214,
	"./balanceAdjustments": 1215,
	"./balanceAdjustments.js": 1215,
	"./balanceHistory": 1216,
	"./balanceHistory.js": 1216,
	"./balanceHistory2": 1217,
	"./balanceHistory2.js": 1217,
	"./balanceHistoryAdminUser": 1218,
	"./balanceHistoryAdminUser.js": 1218,
	"./balanceHistoryBetShop": 1219,
	"./balanceHistoryBetShop.js": 1219,
	"./balanceHistoryBetShop2": 1220,
	"./balanceHistoryBetShop2.js": 1220,
	"./balanceHistoryForAgent": 1221,
	"./balanceHistoryForAgent.js": 1221,
	"./balanceHistoryForBetShop": 1222,
	"./balanceHistoryForBetShop.js": 1222,
	"./balanceHistoryMachine": 1223,
	"./balanceHistoryMachine.js": 1223,
	"./balanceUsers": 1224,
	"./balanceUsers.js": 1224,
	"./bankAccounts": 1225,
	"./bankAccounts.js": 1225,
	"./banks": 1226,
	"./banks.js": 1226,
	"./betShop": 1227,
	"./betShop.js": 1227,
	"./betShopCompetence": 1228,
	"./betShopCompetence.js": 1228,
	"./betShopManagement": 1229,
	"./betShopManagement.js": 1229,
	"./betShopManagement/addInformationBetShop": 1230,
	"./betShopManagement/addInformationBetShop.js": 1230,
	"./betShopManagement/age": 1231,
	"./betShopManagement/age.js": 1231,
	"./betShopManagement/betShop/detailsBetShop": 1017,
	"./betShopManagement/betShop/detailsBetShop.js": 1017,
	"./betShopManagement/betShop/filterBetShop": 328,
	"./betShopManagement/betShop/filterBetShop.js": 328,
	"./betShopManagement/betShop/recordBetShop": 330,
	"./betShopManagement/betShop/recordBetShop.js": 330,
	"./betShopManagement/betShop/recordTableBetShop": 90,
	"./betShopManagement/betShop/recordTableBetShop.js": 90,
	"./betShopManagement/betShop/tableBetShop": 329,
	"./betShopManagement/betShop/tableBetShop.js": 329,
	"./betShopManagement/betShopCompetence/detailsBetShop": 1232,
	"./betShopManagement/betShopCompetence/detailsBetShop.js": 1232,
	"./betShopManagement/betShopCompetence/filterBetShop": 331,
	"./betShopManagement/betShopCompetence/filterBetShop.js": 331,
	"./betShopManagement/betShopCompetence/recordBetShop": 1233,
	"./betShopManagement/betShopCompetence/recordBetShop.js": 1233,
	"./betShopManagement/betShopCompetence/recordTableBetShop": 1234,
	"./betShopManagement/betShopCompetence/recordTableBetShop.js": 1234,
	"./betShopManagement/betShopCompetence/tableBetShop": 332,
	"./betShopManagement/betShopCompetence/tableBetShop.js": 332,
	"./betShopManagement/bonusReportBetShop": 1235,
	"./betShopManagement/bonusReportBetShop.js": 1235,
	"./betShopManagement/cashier/betShopAdvertising": 337,
	"./betShopManagement/cashier/betShopAdvertising.js": 337,
	"./betShopManagement/cashier/betShopAdvertisingCashier": 339,
	"./betShopManagement/cashier/betShopAdvertisingCashier.js": 339,
	"./betShopManagement/cashier/betShopCashier": 1236,
	"./betShopManagement/cashier/betShopCashier.js": 1236,
	"./betShopManagement/cashier/betShopComissions": 1018,
	"./betShopManagement/cashier/betShopComissions.js": 1018,
	"./betShopManagement/cashier/filterCashier": 342,
	"./betShopManagement/cashier/filterCashier.js": 342,
	"./betShopManagement/cashier/tableAdvertising": 338,
	"./betShopManagement/cashier/tableAdvertising.js": 338,
	"./betShopManagement/cashier/tableAdvertisingCashier": 340,
	"./betShopManagement/cashier/tableAdvertisingCashier.js": 340,
	"./betShopManagement/cashier/tableCashier": 91,
	"./betShopManagement/cashier/tableCashier.js": 91,
	"./betShopManagement/cashier/tableComissions": 341,
	"./betShopManagement/cashier/tableComissions.js": 341,
	"./betShopManagement/casinoGamesReportBetShop": 1237,
	"./betShopManagement/casinoGamesReportBetShop.js": 1237,
	"./betShopManagement/comissions": 1238,
	"./betShopManagement/comissions.js": 1238,
	"./betShopManagement/comissions/autoexclusionUsers": 1239,
	"./betShopManagement/comissions/autoexclusionUsers.js": 1239,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1240,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1240,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1241,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1241,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1242,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1242,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1243,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1243,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1244,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1244,
	"./betShopManagement/comissions/betsReport/detailsReport": 1245,
	"./betShopManagement/comissions/betsReport/detailsReport.js": 1245,
	"./betShopManagement/comissions/betsReport/filterReport": 1246,
	"./betShopManagement/comissions/betsReport/filterReport.js": 1246,
	"./betShopManagement/comissions/betsReport/recordReport": 1247,
	"./betShopManagement/comissions/betsReport/recordReport.js": 1247,
	"./betShopManagement/comissions/betsReport/recordTableReport": 1248,
	"./betShopManagement/comissions/betsReport/recordTableReport.js": 1248,
	"./betShopManagement/comissions/betsReport/recordTableTransReport": 1249,
	"./betShopManagement/comissions/betsReport/recordTableTransReport.js": 1249,
	"./betShopManagement/comissions/betsReport/recordTransReport": 1250,
	"./betShopManagement/comissions/betsReport/recordTransReport.js": 1250,
	"./betShopManagement/comissions/betsReport/tableReport": 1251,
	"./betShopManagement/comissions/betsReport/tableReport.js": 1251,
	"./betShopManagement/comissions/betsReportBetShop": 1252,
	"./betShopManagement/comissions/betsReportBetShop.js": 1252,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport": 1253,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport.js": 1253,
	"./betShopManagement/comissions/bonusReport/filterBonusReport": 1254,
	"./betShopManagement/comissions/bonusReport/filterBonusReport.js": 1254,
	"./betShopManagement/comissions/bonusReport/recordBonusReport": 1255,
	"./betShopManagement/comissions/bonusReport/recordBonusReport.js": 1255,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport": 1256,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport.js": 1256,
	"./betShopManagement/comissions/bonusReport/tableBonusReport": 1257,
	"./betShopManagement/comissions/bonusReport/tableBonusReport.js": 1257,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport": 1258,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport.js": 1258,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport": 1259,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport.js": 1259,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport": 1260,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport.js": 1260,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport": 1261,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport.js": 1261,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport": 1262,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport.js": 1262,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport": 1263,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport.js": 1263,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport": 1264,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport.js": 1264,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport": 1265,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport.js": 1265,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport": 1266,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport.js": 1266,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport": 1267,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport.js": 1267,
	"./betShopManagement/comissions/comissions": 1268,
	"./betShopManagement/comissions/comissions.js": 1268,
	"./betShopManagement/comissions/comissions/table": 347,
	"./betShopManagement/comissions/comissions/table.js": 347,
	"./betShopManagement/comissions/comissionsReportBetShop": 1269,
	"./betShopManagement/comissions/comissionsReportBetShop.js": 1269,
	"./betShopManagement/comissions/comissionsReportBetShopDetail": 1270,
	"./betShopManagement/comissions/comissionsReportBetShopDetail.js": 1270,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports": 1271,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports.js": 1271,
	"./betShopManagement/comissions/comissions_report/filter": 348,
	"./betShopManagement/comissions/comissions_report/filter.js": 348,
	"./betShopManagement/comissions/comissions_report/recordDepositReports": 1272,
	"./betShopManagement/comissions/comissions_report/recordDepositReports.js": 1272,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports": 1273,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports.js": 1273,
	"./betShopManagement/comissions/comissions_report/table": 349,
	"./betShopManagement/comissions/comissions_report/table.js": 349,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports": 1274,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports.js": 1274,
	"./betShopManagement/comissions/comissions_report_detail/filter": 350,
	"./betShopManagement/comissions/comissions_report_detail/filter.js": 350,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports": 1275,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports.js": 1275,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports": 1276,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports.js": 1276,
	"./betShopManagement/comissions/comissions_report_detail/table": 351,
	"./betShopManagement/comissions/comissions_report_detail/table.js": 351,
	"./betShopManagement/comissions/expenses": 1277,
	"./betShopManagement/comissions/expenses.js": 1277,
	"./betShopManagement/comissions/expenses/filter": 1278,
	"./betShopManagement/comissions/expenses/filter.js": 1278,
	"./betShopManagement/comissions/expenses/table": 1279,
	"./betShopManagement/comissions/expenses/table.js": 1279,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja": 1280,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja.js": 1280,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja": 1281,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja.js": 1281,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja": 1282,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja.js": 1282,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja": 1283,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja.js": 1283,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja": 1284,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja.js": 1284,
	"./betShopManagement/comissions/incomes": 1285,
	"./betShopManagement/comissions/incomes.js": 1285,
	"./betShopManagement/comissions/incomes/filter": 1286,
	"./betShopManagement/comissions/incomes/filter.js": 1286,
	"./betShopManagement/comissions/incomes/table": 1287,
	"./betShopManagement/comissions/incomes/table.js": 1287,
	"./betShopManagement/comissions/productsThird": 1288,
	"./betShopManagement/comissions/productsThird.js": 1288,
	"./betShopManagement/comissions/productsThird/filter": 1289,
	"./betShopManagement/comissions/productsThird/filter.js": 1289,
	"./betShopManagement/comissions/productsThird/table": 1290,
	"./betShopManagement/comissions/productsThird/table.js": 1290,
	"./betShopManagement/comissions/promotionalCodes": 1291,
	"./betShopManagement/comissions/promotionalCodes.js": 1291,
	"./betShopManagement/comissions/promotionalCodes/filter": 1292,
	"./betShopManagement/comissions/promotionalCodes/filter.js": 1292,
	"./betShopManagement/comissions/promotionalCodes/table": 1293,
	"./betShopManagement/comissions/promotionalCodes/table.js": 1293,
	"./betShopManagement/comissions/withdrawalRequests": 1294,
	"./betShopManagement/comissions/withdrawalRequests.js": 1294,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests": 354,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 354,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest": 352,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest.js": 352,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1295,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1295,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest": 355,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest.js": 355,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest": 353,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest.js": 353,
	"./betShopManagement/configuration/changePassword": 1296,
	"./betShopManagement/configuration/changePassword.js": 1296,
	"./betShopManagement/configuration/changePassword/changePasswordView": 356,
	"./betShopManagement/configuration/changePassword/changePasswordView.js": 356,
	"./betShopManagement/configuration/configNtc": 1297,
	"./betShopManagement/configuration/configNtc.js": 1297,
	"./betShopManagement/configuration/configNtc/configNtcView": 357,
	"./betShopManagement/configuration/configNtc/configNtcView.js": 357,
	"./betShopManagement/configuration/generateToken": 1298,
	"./betShopManagement/configuration/generateToken.js": 1298,
	"./betShopManagement/configuration/generateToken/filter": 358,
	"./betShopManagement/configuration/generateToken/filter.js": 358,
	"./betShopManagement/configuration/generateToken/table": 359,
	"./betShopManagement/configuration/generateToken/table.js": 359,
	"./betShopManagement/configuration/qrgoogle": 1299,
	"./betShopManagement/configuration/qrgoogle.js": 1299,
	"./betShopManagement/configuration/securityChanges": 1300,
	"./betShopManagement/configuration/securityChanges.js": 1300,
	"./betShopManagement/configuration/securityChanges/filter": 1019,
	"./betShopManagement/configuration/securityChanges/filter.js": 1019,
	"./betShopManagement/configuration/securityChanges/table": 360,
	"./betShopManagement/configuration/securityChanges/table.js": 360,
	"./betShopManagement/configurationBetShop": 1301,
	"./betShopManagement/configurationBetShop.js": 1301,
	"./betShopManagement/consultationDocuments/filterConsultationDocuments": 361,
	"./betShopManagement/consultationDocuments/filterConsultationDocuments.js": 361,
	"./betShopManagement/consultationDocuments/tableConsultationDocuments": 362,
	"./betShopManagement/consultationDocuments/tableConsultationDocuments.js": 362,
	"./betShopManagement/depositReportBetShop": 1302,
	"./betShopManagement/depositReportBetShop.js": 1302,
	"./betShopManagement/financescustomerBetShop": 1303,
	"./betShopManagement/financescustomerBetShop.js": 1303,
	"./betShopManagement/financial/bankAccountsBetShop": 1304,
	"./betShopManagement/financial/bankAccountsBetShop.js": 1304,
	"./betShopManagement/financial/bankAccountsBetShop/details": 1305,
	"./betShopManagement/financial/bankAccountsBetShop/details.js": 1305,
	"./betShopManagement/financial/bankAccountsBetShop/filter": 365,
	"./betShopManagement/financial/bankAccountsBetShop/filter.js": 365,
	"./betShopManagement/financial/bankAccountsBetShop/record": 1306,
	"./betShopManagement/financial/bankAccountsBetShop/record.js": 1306,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable": 1307,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable.js": 1307,
	"./betShopManagement/financial/bankAccountsBetShop/table": 366,
	"./betShopManagement/financial/bankAccountsBetShop/table.js": 366,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup": 1308,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup.js": 1308,
	"./betShopManagement/financial/informationFinancialBetShop": 1309,
	"./betShopManagement/financial/informationFinancialBetShop.js": 1309,
	"./betShopManagement/financial/withdrawalRequestsBetShop": 1310,
	"./betShopManagement/financial/withdrawalRequestsBetShop.js": 1310,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop.js": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop": 367,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop.js": 367,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop": 369,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop.js": 369,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop": 139,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop.js": 139,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop": 368,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop.js": 368,
	"./betShopManagement/flujoCajaBetShop": 1311,
	"./betShopManagement/flujoCajaBetShop.js": 1311,
	"./betShopManagement/geo": 1312,
	"./betShopManagement/geo.js": 1312,
	"./betShopManagement/informationBetShop": 1313,
	"./betShopManagement/informationBetShop.js": 1313,
	"./betShopManagement/money": 1314,
	"./betShopManagement/money.js": 1314,
	"./betShopManagement/paymenthistory": 1315,
	"./betShopManagement/paymenthistory.js": 1315,
	"./betShopManagement/positions": 1316,
	"./betShopManagement/positions.js": 1316,
	"./betShopManagement/reports/autoexclusionUsers": 1317,
	"./betShopManagement/reports/autoexclusionUsers.js": 1317,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1318,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1318,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers": 1319,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1319,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers": 1320,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1320,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1321,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1321,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers": 1322,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1322,
	"./betShopManagement/reports/balanceTransactionReport": 1323,
	"./betShopManagement/reports/balanceTransactionReport.js": 1323,
	"./betShopManagement/reports/balanceTransactionReport/filter": 372,
	"./betShopManagement/reports/balanceTransactionReport/filter.js": 372,
	"./betShopManagement/reports/balanceTransactionReport/table": 373,
	"./betShopManagement/reports/balanceTransactionReport/table.js": 373,
	"./betShopManagement/reports/betsReport/detailsReport": 1324,
	"./betShopManagement/reports/betsReport/detailsReport.js": 1324,
	"./betShopManagement/reports/betsReport/filterReport": 50,
	"./betShopManagement/reports/betsReport/filterReport.js": 50,
	"./betShopManagement/reports/betsReport/recordReport": 46,
	"./betShopManagement/reports/betsReport/recordReport.js": 46,
	"./betShopManagement/reports/betsReport/recordTableReport": 1325,
	"./betShopManagement/reports/betsReport/recordTableReport.js": 1325,
	"./betShopManagement/reports/betsReport/recordTableTransReport": 89,
	"./betShopManagement/reports/betsReport/recordTableTransReport.js": 89,
	"./betShopManagement/reports/betsReport/recordTransReport": 45,
	"./betShopManagement/reports/betsReport/recordTransReport.js": 45,
	"./betShopManagement/reports/betsReport/tableReport": 51,
	"./betShopManagement/reports/betsReport/tableReport.js": 51,
	"./betShopManagement/reports/betsReportBetShop": 1326,
	"./betShopManagement/reports/betsReportBetShop.js": 1326,
	"./betShopManagement/reports/bonusReport/detailsBonusReport": 335,
	"./betShopManagement/reports/bonusReport/detailsBonusReport.js": 335,
	"./betShopManagement/reports/bonusReport/filterBonusReport": 333,
	"./betShopManagement/reports/bonusReport/filterBonusReport.js": 333,
	"./betShopManagement/reports/bonusReport/recordBonusReport": 336,
	"./betShopManagement/reports/bonusReport/recordBonusReport.js": 336,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport": 1327,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport.js": 1327,
	"./betShopManagement/reports/bonusReport/tableBonusReport": 334,
	"./betShopManagement/reports/bonusReport/tableBonusReport.js": 334,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport": 345,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport.js": 345,
	"./betShopManagement/reports/casinoReport/filterCasinoReport": 343,
	"./betShopManagement/reports/casinoReport/filterCasinoReport.js": 343,
	"./betShopManagement/reports/casinoReport/recordCasinoReport": 346,
	"./betShopManagement/reports/casinoReport/recordCasinoReport.js": 346,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport": 1328,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport.js": 1328,
	"./betShopManagement/reports/casinoReport/tableCasinoReport": 344,
	"./betShopManagement/reports/casinoReport/tableCasinoReport.js": 344,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport": 1329,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport.js": 1329,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport": 1330,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport.js": 1330,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport": 1331,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport.js": 1331,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport": 1332,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport.js": 1332,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport": 1333,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport.js": 1333,
	"./betShopManagement/reports/deposit_report/detailsDepositReports": 1020,
	"./betShopManagement/reports/deposit_report/detailsDepositReports.js": 1020,
	"./betShopManagement/reports/deposit_report/filterDepositReports": 363,
	"./betShopManagement/reports/deposit_report/filterDepositReports.js": 363,
	"./betShopManagement/reports/deposit_report/recordDepositReports": 137,
	"./betShopManagement/reports/deposit_report/recordDepositReports.js": 137,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports": 1334,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports.js": 1334,
	"./betShopManagement/reports/deposit_report/tableDepositReports": 364,
	"./betShopManagement/reports/deposit_report/tableDepositReports.js": 364,
	"./betShopManagement/reports/expenses": 1335,
	"./betShopManagement/reports/expenses.js": 1335,
	"./betShopManagement/reports/expenses/filter": 52,
	"./betShopManagement/reports/expenses/filter.js": 52,
	"./betShopManagement/reports/expenses/table": 53,
	"./betShopManagement/reports/expenses/table.js": 53,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja": 1336,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja.js": 1336,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja": 370,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja.js": 370,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja": 1337,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja.js": 1337,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja": 1338,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja.js": 1338,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja": 371,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja.js": 371,
	"./betShopManagement/reports/historyMovement": 1339,
	"./betShopManagement/reports/historyMovement.js": 1339,
	"./betShopManagement/reports/historyMovement/filter": 374,
	"./betShopManagement/reports/historyMovement/filter.js": 374,
	"./betShopManagement/reports/historyMovement/table": 375,
	"./betShopManagement/reports/historyMovement/table.js": 375,
	"./betShopManagement/reports/incomes": 1340,
	"./betShopManagement/reports/incomes.js": 1340,
	"./betShopManagement/reports/incomes/filter": 54,
	"./betShopManagement/reports/incomes/filter.js": 54,
	"./betShopManagement/reports/incomes/table": 55,
	"./betShopManagement/reports/incomes/table.js": 55,
	"./betShopManagement/reports/productsThird": 1341,
	"./betShopManagement/reports/productsThird.js": 1341,
	"./betShopManagement/reports/productsThird/filter": 56,
	"./betShopManagement/reports/productsThird/filter.js": 56,
	"./betShopManagement/reports/productsThird/table": 57,
	"./betShopManagement/reports/productsThird/table.js": 57,
	"./betShopManagement/reports/promotionalCodes": 1342,
	"./betShopManagement/reports/promotionalCodes.js": 1342,
	"./betShopManagement/reports/promotionalCodes/filter": 58,
	"./betShopManagement/reports/promotionalCodes/filter.js": 58,
	"./betShopManagement/reports/promotionalCodes/table": 59,
	"./betShopManagement/reports/promotionalCodes/table.js": 59,
	"./betShopManagement/reports/userAffiliatesBetShop": 1343,
	"./betShopManagement/reports/userAffiliatesBetShop.js": 1343,
	"./betShopManagement/reports/userAffiliatesBetShop/filter": 376,
	"./betShopManagement/reports/userAffiliatesBetShop/filter.js": 376,
	"./betShopManagement/reports/userAffiliatesBetShop/table": 377,
	"./betShopManagement/reports/userAffiliatesBetShop/table.js": 377,
	"./betShopManagement/reportscustomerBetShop": 1344,
	"./betShopManagement/reportscustomerBetShop.js": 1344,
	"./betShopManagement/statisticsBetShop": 1345,
	"./betShopManagement/statisticsBetShop.js": 1345,
	"./betShopManagement/tags": 1346,
	"./betShopManagement/tags.js": 1346,
	"./betsHistory": 1347,
	"./betsHistory.js": 1347,
	"./betsHistory2": 1348,
	"./betsHistory2.js": 1348,
	"./betsReport": 1349,
	"./betsReport.js": 1349,
	"./betsReportBetShop": 1350,
	"./betsReportBetShop.js": 1350,
	"./betsReportSecond": 1351,
	"./betsReportSecond.js": 1351,
	"./betsSport": 1352,
	"./betsSport.js": 1352,
	"./betsSportLive": 1353,
	"./betsSportLive.js": 1353,
	"./betsVirtual": 1354,
	"./betsVirtual.js": 1354,
	"./betting": 1355,
	"./betting.js": 1355,
	"./bettingVirtual": 1356,
	"./bettingVirtual.js": 1356,
	"./blockchains": 1357,
	"./blockchains.js": 1357,
	"./bonusReport": 1358,
	"./bonusReport.js": 1358,
	"./bonusReport2": 1359,
	"./bonusReport2.js": 1359,
	"./bonusReports2": 1360,
	"./bonusReports2.js": 1360,
	"./cash/bankAccounts/filter": 323,
	"./cash/bankAccounts/filter.js": 323,
	"./cash/bankAccounts/table": 324,
	"./cash/bankAccounts/table.js": 324,
	"./cash/bets/betHistory": 92,
	"./cash/bets/betHistory.js": 92,
	"./cash/bets/betHistory2": 1361,
	"./cash/bets/betHistory2.js": 1361,
	"./cash/bets/sport": 71,
	"./cash/bets/sport.js": 71,
	"./cash/bets/sportLive": 382,
	"./cash/bets/sportLive.js": 382,
	"./cash/bets/sportVirtual": 383,
	"./cash/bets/sportVirtual.js": 383,
	"./cash/closeBox-edit/creditCards": 392,
	"./cash/closeBox-edit/creditCards.js": 392,
	"./cash/closeBox-edit/otherExpenses": 393,
	"./cash/closeBox-edit/otherExpenses.js": 393,
	"./cash/closeBox-edit/otherIncome": 394,
	"./cash/closeBox-edit/otherIncome.js": 394,
	"./cash/closeBox-edit/products": 395,
	"./cash/closeBox-edit/products.js": 395,
	"./cash/closeBox-edit/total": 396,
	"./cash/closeBox-edit/total.js": 396,
	"./cash/closeBox-old/otherExpenses": 1362,
	"./cash/closeBox-old/otherExpenses.js": 1362,
	"./cash/closeBox-old/otherIncome": 1363,
	"./cash/closeBox-old/otherIncome.js": 1363,
	"./cash/closeBox-old/products": 1364,
	"./cash/closeBox-old/products.js": 1364,
	"./cash/closeBox-old/total": 1365,
	"./cash/closeBox-old/total.js": 1365,
	"./cash/closeBox/creditCards": 397,
	"./cash/closeBox/creditCards.js": 397,
	"./cash/closeBox/otherExpenses": 96,
	"./cash/closeBox/otherExpenses.js": 96,
	"./cash/closeBox/otherIncome": 97,
	"./cash/closeBox/otherIncome.js": 97,
	"./cash/closeBox/products": 98,
	"./cash/closeBox/products.js": 98,
	"./cash/closeBox/total": 99,
	"./cash/closeBox/total.js": 99,
	"./cash/flujocaja/detailsFlujoCaja": 398,
	"./cash/flujocaja/detailsFlujoCaja.js": 398,
	"./cash/flujocaja/filterFlujoCaja": 399,
	"./cash/flujocaja/filterFlujoCaja.js": 399,
	"./cash/flujocaja/recordFlujoCaja": 400,
	"./cash/flujocaja/recordFlujoCaja.js": 400,
	"./cash/flujocaja/recordTableFlujoCaja": 15,
	"./cash/flujocaja/recordTableFlujoCaja.js": 15,
	"./cash/flujocaja/tableFlujoCaja": 401,
	"./cash/flujocaja/tableFlujoCaja.js": 401,
	"./cash/pagoNotaRetiro/PagoNotaRetiro": 402,
	"./cash/pagoNotaRetiro/PagoNotaRetiro.js": 402,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro": 403,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro.js": 403,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro": 1021,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro.js": 1021,
	"./cash/pagopremio/PagoPremio": 404,
	"./cash/pagopremio/PagoPremio.js": 404,
	"./cash/pagopremio/detailsPagoPremio": 405,
	"./cash/pagopremio/detailsPagoPremio.js": 405,
	"./cash/pagopremio/filterPagoPremio": 406,
	"./cash/pagopremio/filterPagoPremio.js": 406,
	"./cash/pagopremio/recordPagoPremio": 407,
	"./cash/pagopremio/recordPagoPremio.js": 407,
	"./cash/pagopremio/recordTablePagoPremio": 1366,
	"./cash/pagopremio/recordTablePagoPremio.js": 1366,
	"./cash/pagopremio/tablePagoPremio": 408,
	"./cash/pagopremio/tablePagoPremio.js": 408,
	"./cash/pagopremiovirtuales/PagoPremio": 409,
	"./cash/pagopremiovirtuales/PagoPremio.js": 409,
	"./cash/pagopremiovirtuales/detailsPagoPremio": 410,
	"./cash/pagopremiovirtuales/detailsPagoPremio.js": 410,
	"./cash/pagopremiovirtuales/filterPagoPremio": 411,
	"./cash/pagopremiovirtuales/filterPagoPremio.js": 411,
	"./cash/pagopremiovirtuales/recordPagoPremio": 412,
	"./cash/pagopremiovirtuales/recordPagoPremio.js": 412,
	"./cash/pagopremiovirtuales/recordTablePagoPremio": 1367,
	"./cash/pagopremiovirtuales/recordTablePagoPremio.js": 1367,
	"./cash/pagopremiovirtuales/tablePagoPremio": 413,
	"./cash/pagopremiovirtuales/tablePagoPremio.js": 413,
	"./cash/payPrizesLoyalty/PagoPremio": 414,
	"./cash/payPrizesLoyalty/PagoPremio.js": 414,
	"./cash/payPrizesLoyalty/filterPagoPremio": 415,
	"./cash/payPrizesLoyalty/filterPagoPremio.js": 415,
	"./cash/recargacredito/RecargaCredito": 416,
	"./cash/recargacredito/RecargaCredito.js": 416,
	"./cash/recargacredito/filterRecargaCredito": 417,
	"./cash/recargacredito/filterRecargaCredito.js": 417,
	"./cash/recargacreditoAgent/RecargaCredito": 418,
	"./cash/recargacreditoAgent/RecargaCredito.js": 418,
	"./cash/recargacreditoAgent/filterRecargaCredito": 419,
	"./cash/recargacreditoAgent/filterRecargaCredito.js": 419,
	"./cash/withdrawal/filter": 420,
	"./cash/withdrawal/filter.js": 420,
	"./cash/withdrawal/table": 421,
	"./cash/withdrawal/table.js": 421,
	"./cashiers": 1368,
	"./cashiers.js": 1368,
	"./casinoGamesReport": 1369,
	"./casinoGamesReport.js": 1369,
	"./casinoGamesReport2": 1371,
	"./casinoGamesReport2.js": 1371,
	"./categories": 1372,
	"./categories.js": 1372,
	"./categoriesProducts": 1373,
	"./categoriesProducts.js": 1373,
	"./closeBox": 1374,
	"./closeBox-old": 1375,
	"./closeBox-old.js": 1375,
	"./closeBox.js": 1374,
	"./closeBoxEdit": 1376,
	"./closeBoxEdit.js": 1376,
	"./comissionsReport": 1377,
	"./comissionsReport.js": 1377,
	"./comissionsReport2": 1378,
	"./comissionsReport2.js": 1378,
	"./commisionsPay": 1379,
	"./commisionsPay.js": 1379,
	"./competitors/competitors": 1380,
	"./competitors/competitors.js": 1380,
	"./competitors/filter": 438,
	"./competitors/filter.js": 438,
	"./competitors/table": 439,
	"./competitors/table.js": 439,
	"./consolidatedIncome": 1381,
	"./consolidatedIncome.js": 1381,
	"./consolidatedIncomeOwner": 1382,
	"./consolidatedIncomeOwner.js": 1382,
	"./consolidatedIncomeOwner2": 1383,
	"./consolidatedIncomeOwner2.js": 1383,
	"./consultationDocuments": 1384,
	"./consultationDocuments.js": 1384,
	"./contingency": 1385,
	"./contingency.js": 1385,
	"./countries": 1386,
	"./countries.js": 1386,
	"./coupons": 1387,
	"./coupons.js": 1387,
	"./couponsReport": 1388,
	"./couponsReport.js": 1388,
	"./cryptoBlockchain": 1389,
	"./cryptoBlockchain.js": 1389,
	"./cryptos": 1390,
	"./cryptos.js": 1390,
	"./customReport": 1391,
	"./customReport.js": 1391,
	"./customers": 1392,
	"./customers.js": 1392,
	"./customers/age": 35,
	"./customers/age.js": 35,
	"./customers/bonusReport": 1393,
	"./customers/bonusReport.js": 1393,
	"./customers/bonusReport2": 1394,
	"./customers/bonusReport2.js": 1394,
	"./customers/casinoGamesReport": 1395,
	"./customers/casinoGamesReport.js": 1395,
	"./customers/configuration": 1396,
	"./customers/configuration.js": 1396,
	"./customers/configuration/changePassword": 1397,
	"./customers/configuration/changePassword.js": 1397,
	"./customers/configuration/changePassword/changePasswordView": 104,
	"./customers/configuration/changePassword/changePasswordView.js": 104,
	"./customers/configuration/generateToken": 1398,
	"./customers/configuration/generateToken.js": 1398,
	"./customers/configuration/generateToken/filter": 105,
	"./customers/configuration/generateToken/filter.js": 105,
	"./customers/configuration/generateToken/table": 106,
	"./customers/configuration/generateToken/table.js": 106,
	"./customers/configuration/limitChanges": 1399,
	"./customers/configuration/limitChanges.js": 1399,
	"./customers/configuration/securityChanges": 1400,
	"./customers/configuration/securityChanges.js": 1400,
	"./customers/configuration/securityChanges/filter": 83,
	"./customers/configuration/securityChanges/filter.js": 83,
	"./customers/configuration/securityChanges/securityForm": 85,
	"./customers/configuration/securityChanges/securityForm.js": 85,
	"./customers/configuration/securityChanges/table": 49,
	"./customers/configuration/securityChanges/table.js": 49,
	"./customers/configuration/securityChanges2": 1401,
	"./customers/configuration/securityChanges2.js": 1401,
	"./customers/depositReport": 1402,
	"./customers/depositReport.js": 1402,
	"./customers/financescustomer": 1403,
	"./customers/financescustomer.js": 1403,
	"./customers/financial/bankAccounts": 1404,
	"./customers/financial/bankAccounts.js": 1404,
	"./customers/financial/bankAccounts/details": 1026,
	"./customers/financial/bankAccounts/details.js": 1026,
	"./customers/financial/bankAccounts/filter": 109,
	"./customers/financial/bankAccounts/filter.js": 109,
	"./customers/financial/bankAccounts/record": 461,
	"./customers/financial/bankAccounts/record.js": 461,
	"./customers/financial/bankAccounts/recordTable": 1405,
	"./customers/financial/bankAccounts/recordTable.js": 1405,
	"./customers/financial/bankAccounts/table": 110,
	"./customers/financial/bankAccounts/table.js": 110,
	"./customers/financial/bankAccounts/tablePopup": 1406,
	"./customers/financial/bankAccounts/tablePopup.js": 1406,
	"./customers/financial/informationFinancial": 1407,
	"./customers/financial/informationFinancial.js": 1407,
	"./customers/financial/withdrawalRequests": 1408,
	"./customers/financial/withdrawalRequests.js": 1408,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests": 78,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests.js": 78,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest": 111,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest.js": 111,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest": 64,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 64,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest": 79,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest.js": 79,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest": 112,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest.js": 112,
	"./customers/geo": 20,
	"./customers/geo.js": 20,
	"./customers/information": 1409,
	"./customers/information.js": 1409,
	"./customers/money": 34,
	"./customers/money.js": 34,
	"./customers/paymenthistory": 462,
	"./customers/paymenthistory.js": 462,
	"./customers/players/filter": 463,
	"./customers/players/filter.js": 463,
	"./customers/players/table": 464,
	"./customers/players/table.js": 464,
	"./customers/players2/filter": 465,
	"./customers/players2/filter.js": 465,
	"./customers/players2/table": 466,
	"./customers/players2/table.js": 466,
	"./customers/playersAggregator/filter": 467,
	"./customers/playersAggregator/filter.js": 467,
	"./customers/playersAggregator/table": 468,
	"./customers/playersAggregator/table.js": 468,
	"./customers/positions": 21,
	"./customers/positions.js": 21,
	"./customers/referralsReport": 1410,
	"./customers/referralsReport.js": 1410,
	"./customers/reports/autoexclusionUsers": 1411,
	"./customers/reports/autoexclusionUsers.js": 1411,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers": 28,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 28,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers": 22,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 22,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers": 68,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 68,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 88,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 88,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers": 23,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 23,
	"./customers/reports/balanceAdjustments": 1412,
	"./customers/reports/balanceAdjustments.js": 1412,
	"./customers/reports/balanceAdjustments/filter": 471,
	"./customers/reports/balanceAdjustments/filter.js": 471,
	"./customers/reports/balanceAdjustments/table": 472,
	"./customers/reports/balanceAdjustments/table.js": 472,
	"./customers/reports/balanceHistory": 1413,
	"./customers/reports/balanceHistory.js": 1413,
	"./customers/reports/balanceHistory/filter": 473,
	"./customers/reports/balanceHistory/filter.js": 473,
	"./customers/reports/balanceHistory/table": 474,
	"./customers/reports/balanceHistory/table.js": 474,
	"./customers/reports/betsReport": 1414,
	"./customers/reports/betsReport.js": 1414,
	"./customers/reports/betsReport/detailsReport": 1415,
	"./customers/reports/betsReport/detailsReport.js": 1415,
	"./customers/reports/betsReport/filterReport": 113,
	"./customers/reports/betsReport/filterReport.js": 113,
	"./customers/reports/betsReport/recordReport": 37,
	"./customers/reports/betsReport/recordReport.js": 37,
	"./customers/reports/betsReport/recordTableReport": 42,
	"./customers/reports/betsReport/recordTableReport.js": 42,
	"./customers/reports/betsReport/recordTableTransReport": 41,
	"./customers/reports/betsReport/recordTableTransReport.js": 41,
	"./customers/reports/betsReport/recordTransReport": 80,
	"./customers/reports/betsReport/recordTransReport.js": 80,
	"./customers/reports/betsReport/tableReport": 114,
	"./customers/reports/betsReport/tableReport.js": 114,
	"./customers/reports/bonusReport/detailsBonusReport": 73,
	"./customers/reports/bonusReport/detailsBonusReport.js": 73,
	"./customers/reports/bonusReport/filterBonusReport": 100,
	"./customers/reports/bonusReport/filterBonusReport.js": 100,
	"./customers/reports/bonusReport/recordBonusReport": 74,
	"./customers/reports/bonusReport/recordBonusReport.js": 74,
	"./customers/reports/bonusReport/recordTableBonusReport": 63,
	"./customers/reports/bonusReport/recordTableBonusReport.js": 63,
	"./customers/reports/bonusReport/tableBonusReport": 101,
	"./customers/reports/bonusReport/tableBonusReport.js": 101,
	"./customers/reports/bonusReport2/detailsBonusReport": 149,
	"./customers/reports/bonusReport2/detailsBonusReport.js": 149,
	"./customers/reports/bonusReport2/filterBonusReport": 459,
	"./customers/reports/bonusReport2/filterBonusReport.js": 459,
	"./customers/reports/bonusReport2/recordBonusReport": 150,
	"./customers/reports/bonusReport2/recordBonusReport.js": 150,
	"./customers/reports/bonusReport2/recordTableBonusReport": 1416,
	"./customers/reports/bonusReport2/recordTableBonusReport.js": 1416,
	"./customers/reports/bonusReport2/tableBonusReport": 460,
	"./customers/reports/bonusReport2/tableBonusReport.js": 460,
	"./customers/reports/casinoReport/detailsCasinoReport": 75,
	"./customers/reports/casinoReport/detailsCasinoReport.js": 75,
	"./customers/reports/casinoReport/filterCasinoReport": 102,
	"./customers/reports/casinoReport/filterCasinoReport.js": 102,
	"./customers/reports/casinoReport/recordCasinoReport": 76,
	"./customers/reports/casinoReport/recordCasinoReport.js": 76,
	"./customers/reports/casinoReport/recordTableCasinoReport": 40,
	"./customers/reports/casinoReport/recordTableCasinoReport.js": 40,
	"./customers/reports/casinoReport/tableCasinoReport": 103,
	"./customers/reports/casinoReport/tableCasinoReport.js": 103,
	"./customers/reports/casinoReport2/detailsCasinoReport": 1417,
	"./customers/reports/casinoReport2/detailsCasinoReport.js": 1417,
	"./customers/reports/casinoReport2/filterCasinoReport": 1418,
	"./customers/reports/casinoReport2/filterCasinoReport.js": 1418,
	"./customers/reports/casinoReport2/recordCasinoReport": 1419,
	"./customers/reports/casinoReport2/recordCasinoReport.js": 1419,
	"./customers/reports/casinoReport2/recordTableCasinoReport": 1420,
	"./customers/reports/casinoReport2/recordTableCasinoReport.js": 1420,
	"./customers/reports/casinoReport2/tableCasinoReport": 1421,
	"./customers/reports/casinoReport2/tableCasinoReport.js": 1421,
	"./customers/reports/deposit_report/detailsDepositReports": 171,
	"./customers/reports/deposit_report/detailsDepositReports.js": 171,
	"./customers/reports/deposit_report/filterDepositReports": 107,
	"./customers/reports/deposit_report/filterDepositReports.js": 107,
	"./customers/reports/deposit_report/recordDepositReports": 77,
	"./customers/reports/deposit_report/recordDepositReports.js": 77,
	"./customers/reports/deposit_report/recordTableDepositReports": 19,
	"./customers/reports/deposit_report/recordTableDepositReports.js": 19,
	"./customers/reports/deposit_report/tableDepositReports": 108,
	"./customers/reports/deposit_report/tableDepositReports.js": 108,
	"./customers/reports/historyMovement": 1422,
	"./customers/reports/historyMovement.js": 1422,
	"./customers/reports/historyMovement/filter": 475,
	"./customers/reports/historyMovement/filter.js": 475,
	"./customers/reports/historyMovement/table": 476,
	"./customers/reports/historyMovement/table.js": 476,
	"./customers/reports/historyPoints": 1423,
	"./customers/reports/historyPoints.js": 1423,
	"./customers/reports/historyPoints/filter": 477,
	"./customers/reports/historyPoints/filter.js": 477,
	"./customers/reports/historyPoints/table": 478,
	"./customers/reports/historyPoints/table.js": 478,
	"./customers/reports/logsUser": 1424,
	"./customers/reports/logsUser.js": 1424,
	"./customers/reports/logsUser/filter": 479,
	"./customers/reports/logsUser/filter.js": 479,
	"./customers/reports/logsUser/table": 480,
	"./customers/reports/logsUser/table.js": 480,
	"./customers/reports/loyaltyLevelChangeHistory": 1027,
	"./customers/reports/loyaltyLevelChangeHistory.js": 1027,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 481,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 481,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 482,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 482,
	"./customers/reports/notesUser": 1425,
	"./customers/reports/notesUser.js": 1425,
	"./customers/reports/notesUser/filter": 483,
	"./customers/reports/notesUser/filter.js": 483,
	"./customers/reports/notesUser/table": 484,
	"./customers/reports/notesUser/table.js": 484,
	"./customers/reports/playerPrizesLoyalty": 1426,
	"./customers/reports/playerPrizesLoyalty.js": 1426,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty": 485,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty.js": 485,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty": 486,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty.js": 486,
	"./customers/reports/playerRoulette": 1427,
	"./customers/reports/playerRoulette.js": 1427,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport": 487,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport.js": 487,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport": 488,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport.js": 488,
	"./customers/reports/qualifyingPointsRecord": 1428,
	"./customers/reports/qualifyingPointsRecord.js": 1428,
	"./customers/reports/qualifyingPointsRecordReport/filter": 489,
	"./customers/reports/qualifyingPointsRecordReport/filter.js": 489,
	"./customers/reports/qualifyingPointsRecordReport/table": 490,
	"./customers/reports/qualifyingPointsRecordReport/table.js": 490,
	"./customers/reports/referralsReport/filterReferralsReports": 469,
	"./customers/reports/referralsReport/filterReferralsReports.js": 469,
	"./customers/reports/referralsReport/recordReferralsReports": 1429,
	"./customers/reports/referralsReport/recordReferralsReports.js": 1429,
	"./customers/reports/referralsReport/recordTableReferralsReports": 1430,
	"./customers/reports/referralsReport/recordTableReferralsReports.js": 1430,
	"./customers/reports/referralsReport/tableReferralsReports": 470,
	"./customers/reports/referralsReport/tableReferralsReports.js": 470,
	"./customers/reports/registeredDocument": 1431,
	"./customers/reports/registeredDocument.js": 1431,
	"./customers/reports/registeredDocuments/filter": 491,
	"./customers/reports/registeredDocuments/filter.js": 491,
	"./customers/reports/registeredDocuments/table": 492,
	"./customers/reports/registeredDocuments/table.js": 492,
	"./customers/reports/sessionsReport": 1432,
	"./customers/reports/sessionsReport.js": 1432,
	"./customers/reports/sessionsReport/detailsSessionsReport": 495,
	"./customers/reports/sessionsReport/detailsSessionsReport.js": 495,
	"./customers/reports/sessionsReport/filterSessionsReport": 493,
	"./customers/reports/sessionsReport/filterSessionsReport.js": 493,
	"./customers/reports/sessionsReport/recordSessionsReport": 1028,
	"./customers/reports/sessionsReport/recordSessionsReport.js": 1028,
	"./customers/reports/sessionsReport/recordTableSessionsReport": 1029,
	"./customers/reports/sessionsReport/recordTableSessionsReport.js": 1029,
	"./customers/reports/sessionsReport/tableSessionsReport": 494,
	"./customers/reports/sessionsReport/tableSessionsReport.js": 494,
	"./customers/reports/sessionsReport2": 1433,
	"./customers/reports/sessionsReport2.js": 1433,
	"./customers/reports/sessionsReport2/filter": 496,
	"./customers/reports/sessionsReport2/filter.js": 496,
	"./customers/reports/sessionsReport2/table": 497,
	"./customers/reports/sessionsReport2/table.js": 497,
	"./customers/reports/walletsReport": 1434,
	"./customers/reports/walletsReport.js": 1434,
	"./customers/reports/walletsReport/filter": 498,
	"./customers/reports/walletsReport/filter.js": 498,
	"./customers/reports/walletsReport/table": 499,
	"./customers/reports/walletsReport/table.js": 499,
	"./customers/reportscustomer": 1435,
	"./customers/reportscustomer.js": 1435,
	"./customers/statistics": 1436,
	"./customers/statistics.js": 1436,
	"./customers/tags": 36,
	"./customers/tags.js": 36,
	"./customersAggregator": 1437,
	"./customersAggregator.js": 1437,
	"./customersAggregator/age": 1438,
	"./customersAggregator/age.js": 1438,
	"./customersAggregator/bonusReport": 1439,
	"./customersAggregator/bonusReport.js": 1439,
	"./customersAggregator/casinoGamesReport": 1440,
	"./customersAggregator/casinoGamesReport.js": 1440,
	"./customersAggregator/configuration": 1441,
	"./customersAggregator/configuration.js": 1441,
	"./customersAggregator/configuration/changePassword": 1442,
	"./customersAggregator/configuration/changePassword.js": 1442,
	"./customersAggregator/configuration/changePassword/changePasswordView": 1443,
	"./customersAggregator/configuration/changePassword/changePasswordView.js": 1443,
	"./customersAggregator/configuration/generateToken": 1444,
	"./customersAggregator/configuration/generateToken.js": 1444,
	"./customersAggregator/configuration/generateToken/filter": 1445,
	"./customersAggregator/configuration/generateToken/filter.js": 1445,
	"./customersAggregator/configuration/generateToken/table": 1446,
	"./customersAggregator/configuration/generateToken/table.js": 1446,
	"./customersAggregator/configuration/securityChanges": 1447,
	"./customersAggregator/configuration/securityChanges.js": 1447,
	"./customersAggregator/configuration/securityChanges/filter": 1448,
	"./customersAggregator/configuration/securityChanges/filter.js": 1448,
	"./customersAggregator/configuration/securityChanges/table": 1449,
	"./customersAggregator/configuration/securityChanges/table.js": 1449,
	"./customersAggregator/depositReport": 1450,
	"./customersAggregator/depositReport.js": 1450,
	"./customersAggregator/financescustomer": 1451,
	"./customersAggregator/financescustomer.js": 1451,
	"./customersAggregator/financial/bankAccounts": 1452,
	"./customersAggregator/financial/bankAccounts.js": 1452,
	"./customersAggregator/financial/bankAccounts/details": 1453,
	"./customersAggregator/financial/bankAccounts/details.js": 1453,
	"./customersAggregator/financial/bankAccounts/filter": 1454,
	"./customersAggregator/financial/bankAccounts/filter.js": 1454,
	"./customersAggregator/financial/bankAccounts/record": 1455,
	"./customersAggregator/financial/bankAccounts/record.js": 1455,
	"./customersAggregator/financial/bankAccounts/recordTable": 1456,
	"./customersAggregator/financial/bankAccounts/recordTable.js": 1456,
	"./customersAggregator/financial/bankAccounts/table": 1457,
	"./customersAggregator/financial/bankAccounts/table.js": 1457,
	"./customersAggregator/financial/bankAccounts/tablePopup": 1458,
	"./customersAggregator/financial/bankAccounts/tablePopup.js": 1458,
	"./customersAggregator/financial/informationFinancial": 1459,
	"./customersAggregator/financial/informationFinancial.js": 1459,
	"./customersAggregator/financial/withdrawalRequests": 1460,
	"./customersAggregator/financial/withdrawalRequests.js": 1460,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests": 1461,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests.js": 1461,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest": 1462,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest.js": 1462,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest": 1463,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 1463,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest": 1464,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest.js": 1464,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest": 1465,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest.js": 1465,
	"./customersAggregator/geo": 1466,
	"./customersAggregator/geo.js": 1466,
	"./customersAggregator/information": 1467,
	"./customersAggregator/information.js": 1467,
	"./customersAggregator/money": 1468,
	"./customersAggregator/money.js": 1468,
	"./customersAggregator/paymenthistory": 1469,
	"./customersAggregator/paymenthistory.js": 1469,
	"./customersAggregator/players/filter": 1470,
	"./customersAggregator/players/filter.js": 1470,
	"./customersAggregator/players/table": 1471,
	"./customersAggregator/players/table.js": 1471,
	"./customersAggregator/playersAggregator/filter": 1472,
	"./customersAggregator/playersAggregator/filter.js": 1472,
	"./customersAggregator/playersAggregator/table": 1473,
	"./customersAggregator/playersAggregator/table.js": 1473,
	"./customersAggregator/positions": 1474,
	"./customersAggregator/positions.js": 1474,
	"./customersAggregator/reports/autoexclusionUsers": 1475,
	"./customersAggregator/reports/autoexclusionUsers.js": 1475,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1476,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1476,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers": 1477,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1477,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers": 1478,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1478,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1479,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1479,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers": 1480,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1480,
	"./customersAggregator/reports/betsReport": 1481,
	"./customersAggregator/reports/betsReport.js": 1481,
	"./customersAggregator/reports/betsReport/detailsReport": 1482,
	"./customersAggregator/reports/betsReport/detailsReport.js": 1482,
	"./customersAggregator/reports/betsReport/filterReport": 1483,
	"./customersAggregator/reports/betsReport/filterReport.js": 1483,
	"./customersAggregator/reports/betsReport/recordReport": 1484,
	"./customersAggregator/reports/betsReport/recordReport.js": 1484,
	"./customersAggregator/reports/betsReport/recordTableReport": 1485,
	"./customersAggregator/reports/betsReport/recordTableReport.js": 1485,
	"./customersAggregator/reports/betsReport/recordTableTransReport": 1486,
	"./customersAggregator/reports/betsReport/recordTableTransReport.js": 1486,
	"./customersAggregator/reports/betsReport/recordTransReport": 1487,
	"./customersAggregator/reports/betsReport/recordTransReport.js": 1487,
	"./customersAggregator/reports/betsReport/tableReport": 1488,
	"./customersAggregator/reports/betsReport/tableReport.js": 1488,
	"./customersAggregator/reports/bonusReport/detailsBonusReport": 1489,
	"./customersAggregator/reports/bonusReport/detailsBonusReport.js": 1489,
	"./customersAggregator/reports/bonusReport/filterBonusReport": 1490,
	"./customersAggregator/reports/bonusReport/filterBonusReport.js": 1490,
	"./customersAggregator/reports/bonusReport/recordBonusReport": 1491,
	"./customersAggregator/reports/bonusReport/recordBonusReport.js": 1491,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport": 1492,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport.js": 1492,
	"./customersAggregator/reports/bonusReport/tableBonusReport": 1493,
	"./customersAggregator/reports/bonusReport/tableBonusReport.js": 1493,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport": 1494,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport.js": 1494,
	"./customersAggregator/reports/casinoReport/filterCasinoReport": 1495,
	"./customersAggregator/reports/casinoReport/filterCasinoReport.js": 1495,
	"./customersAggregator/reports/casinoReport/recordCasinoReport": 1496,
	"./customersAggregator/reports/casinoReport/recordCasinoReport.js": 1496,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport": 1497,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport.js": 1497,
	"./customersAggregator/reports/casinoReport/tableCasinoReport": 1498,
	"./customersAggregator/reports/casinoReport/tableCasinoReport.js": 1498,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport": 1499,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport.js": 1499,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport": 1500,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport.js": 1500,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport": 1501,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport.js": 1501,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport": 1502,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport.js": 1502,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport": 1503,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport.js": 1503,
	"./customersAggregator/reports/deposit_report/detailsDepositReports": 1504,
	"./customersAggregator/reports/deposit_report/detailsDepositReports.js": 1504,
	"./customersAggregator/reports/deposit_report/filterDepositReports": 1505,
	"./customersAggregator/reports/deposit_report/filterDepositReports.js": 1505,
	"./customersAggregator/reports/deposit_report/recordDepositReports": 1506,
	"./customersAggregator/reports/deposit_report/recordDepositReports.js": 1506,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports": 1507,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports.js": 1507,
	"./customersAggregator/reports/deposit_report/tableDepositReports": 1508,
	"./customersAggregator/reports/deposit_report/tableDepositReports.js": 1508,
	"./customersAggregator/reportscustomer": 1509,
	"./customersAggregator/reportscustomer.js": 1509,
	"./customersAggregator/statistics": 1510,
	"./customersAggregator/statistics.js": 1510,
	"./customersAggregator/tags": 1511,
	"./customersAggregator/tags.js": 1511,
	"./dashboard": 1512,
	"./dashboard.js": 1512,
	"./dashboard/dataview": 87,
	"./dashboard/dataview.js": 87,
	"./dashboard/jugadoresActivos": 84,
	"./dashboard/jugadoresActivos.js": 84,
	"./dashboard/jugadoresNuevos": 129,
	"./dashboard/jugadoresNuevos.js": 129,
	"./dates": 500,
	"./dates.js": 500,
	"./demos": 1513,
	"./demos.js": 1513,
	"./depositReport": 1514,
	"./depositReport.js": 1514,
	"./depositReport2": 1515,
	"./depositReport2.js": 1515,
	"./depositReport3": 1516,
	"./depositReport3.js": 1516,
	"./depositReportBetShop": 1517,
	"./depositReportBetShop.js": 1517,
	"./depositReportFranchise": 1518,
	"./depositReportFranchise.js": 1518,
	"./depositRequests": 1519,
	"./depositRequests.js": 1519,
	"./eliminateNoteWithdraw": 1520,
	"./eliminateNoteWithdraw.js": 1520,
	"./emailsReport": 1521,
	"./emailsReport.js": 1521,
	"./financial/depositRequests/filter": 511,
	"./financial/depositRequests/filter.js": 511,
	"./financial/depositRequests/record": 154,
	"./financial/depositRequests/record.js": 154,
	"./financial/depositRequests/recordTable": 513,
	"./financial/depositRequests/recordTable.js": 513,
	"./financial/depositRequests/table": 512,
	"./financial/depositRequests/table.js": 512,
	"./financial/withdrawalRequests": 1522,
	"./financial/withdrawalRequests.js": 1522,
	"./financial/withdrawalRequests/detailsWithdrawalRequests": 81,
	"./financial/withdrawalRequests/detailsWithdrawalRequests.js": 81,
	"./financial/withdrawalRequests/filterWithdrawalRequest": 115,
	"./financial/withdrawalRequests/filterWithdrawalRequest.js": 115,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest": 16,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest.js": 16,
	"./financial/withdrawalRequests/recordWithdrawalRequest": 82,
	"./financial/withdrawalRequests/recordWithdrawalRequest.js": 82,
	"./financial/withdrawalRequests/tableWithdrawalRequest": 116,
	"./financial/withdrawalRequests/tableWithdrawalRequest.js": 116,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests": 157,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 157,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest": 520,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 520,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1523,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1523,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest": 158,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 158,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest": 521,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 521,
	"./flujoCaja": 1524,
	"./flujoCaja.js": 1524,
	"./franchisee": 1525,
	"./franchisee.js": 1525,
	"./franchises": 1526,
	"./franchises.js": 1526,
	"./futureEvents": 1527,
	"./futureEvents.js": 1527,
	"./gamePerformanceReport": 1528,
	"./gamePerformanceReport.js": 1528,
	"./getReportStructureGames": 1529,
	"./getReportStructureGames.js": 1529,
	"./goldenRace": 1530,
	"./goldenRace.js": 1530,
	"./historicalCashFlow": 1531,
	"./historicalCashFlow.js": 1531,
	"./historyMovement": 1532,
	"./historyMovement.js": 1532,
	"./historyMovement/filter": 1533,
	"./historyMovement/filter.js": 1533,
	"./historyMovement/table": 1534,
	"./historyMovement/table.js": 1534,
	"./historyMovementBetShop": 1535,
	"./historyMovementBetShop.js": 1535,
	"./historyPoints": 1536,
	"./historyPoints.js": 1536,
	"./information/details": 25,
	"./information/details.js": 25,
	"./information/filter": 43,
	"./information/filter.js": 43,
	"./information/record": 26,
	"./information/record.js": 26,
	"./information/recordTable": 1537,
	"./information/recordTable.js": 1537,
	"./information/table": 44,
	"./information/table.js": 44,
	"./informationCasino": 1538,
	"./informationCasino.js": 1538,
	"./informationHipica": 1539,
	"./informationHipica.js": 1539,
	"./informationLiveCasino": 1540,
	"./informationLiveCasino.js": 1540,
	"./informationVirtual": 1541,
	"./informationVirtual.js": 1541,
	"./informeCasino": 1542,
	"./informeCasino.js": 1542,
	"./informeGerencial": 1543,
	"./informeGerencial.js": 1543,
	"./informeGerencial2": 1544,
	"./informeGerencial2.js": 1544,
	"./informeGerencialAgentes2": 1545,
	"./informeGerencialAgentes2.js": 1545,
	"./informeGerencialUsuarios2": 1546,
	"./informeGerencialUsuarios2.js": 1546,
	"./jackpotInternationalReport2": 1547,
	"./jackpotInternationalReport2.js": 1547,
	"./jackpotPaymentReports": 1548,
	"./jackpotPaymentReports.js": 1548,
	"./jackpotPaymentReports2": 1549,
	"./jackpotPaymentReports2.js": 1549,
	"./jackpotPrizeReport": 1550,
	"./jackpotPrizeReport.js": 1550,
	"./jackpotPrizeReportSportBet": 1551,
	"./jackpotPrizeReportSportBet.js": 1551,
	"./jackpotWinnersReport": 1552,
	"./jackpotWinnersReport.js": 1552,
	"./landingReport": 1553,
	"./landingReport.js": 1553,
	"./landingReport2": 1554,
	"./landingReport2.js": 1554,
	"./leagues/AddLeague": 1555,
	"./leagues/AddLeague.js": 1555,
	"./leagues/addLeagueManagement": 1556,
	"./leagues/addLeagueManagement.js": 1556,
	"./leagues/configuration": 1557,
	"./leagues/configuration.js": 1557,
	"./leagues/configuration/changePassword": 1558,
	"./leagues/configuration/changePassword.js": 1558,
	"./leagues/configuration/changePassword/changePasswordView": 1559,
	"./leagues/configuration/changePassword/changePasswordView.js": 1559,
	"./leagues/configuration/generateToken": 1560,
	"./leagues/configuration/generateToken.js": 1560,
	"./leagues/configuration/generateToken/filter": 1561,
	"./leagues/configuration/generateToken/filter.js": 1561,
	"./leagues/configuration/generateToken/table": 1562,
	"./leagues/configuration/generateToken/table.js": 1562,
	"./leagues/configuration/qrgoogle": 1563,
	"./leagues/configuration/qrgoogle.js": 1563,
	"./leagues/configuration/securityChanges": 1564,
	"./leagues/configuration/securityChanges.js": 1564,
	"./leagues/configuration/securityChanges/filter": 1565,
	"./leagues/configuration/securityChanges/filter.js": 1565,
	"./leagues/configuration/securityChanges/table": 1566,
	"./leagues/configuration/securityChanges/table.js": 1566,
	"./leagues/information": 1567,
	"./leagues/information.js": 1567,
	"./leagues/leagues-list/filter": 573,
	"./leagues/leagues-list/filter.js": 573,
	"./leagues/leagues-list/table": 574,
	"./leagues/leagues-list/table.js": 574,
	"./leagues/leaguesList": 1568,
	"./leagues/leaguesList.js": 1568,
	"./leagues/leaguesManagement": 1569,
	"./leagues/leaguesManagement.js": 1569,
	"./leagues/reports": 1570,
	"./leagues/reports.js": 1570,
	"./leagues/reports/betsReport": 1571,
	"./leagues/reports/betsReport.js": 1571,
	"./leagues/reports/betsReport/detailsReport": 1572,
	"./leagues/reports/betsReport/detailsReport.js": 1572,
	"./leagues/reports/betsReport/filterReport": 576,
	"./leagues/reports/betsReport/filterReport.js": 576,
	"./leagues/reports/betsReport/recordReport": 1573,
	"./leagues/reports/betsReport/recordReport.js": 1573,
	"./leagues/reports/betsReport/recordTableReport": 1574,
	"./leagues/reports/betsReport/recordTableReport.js": 1574,
	"./leagues/reports/betsReport/recordTableTransReport": 1575,
	"./leagues/reports/betsReport/recordTableTransReport.js": 1575,
	"./leagues/reports/betsReport/recordTransReport": 578,
	"./leagues/reports/betsReport/recordTransReport.js": 578,
	"./leagues/reports/betsReport/tableReport": 577,
	"./leagues/reports/betsReport/tableReport.js": 577,
	"./leagues/reports/casinoGamesReport": 1576,
	"./leagues/reports/casinoGamesReport.js": 1576,
	"./leagues/reports/casinoReport/detailsCasinoReport": 581,
	"./leagues/reports/casinoReport/detailsCasinoReport.js": 581,
	"./leagues/reports/casinoReport/filterCasinoReport": 579,
	"./leagues/reports/casinoReport/filterCasinoReport.js": 579,
	"./leagues/reports/casinoReport/recordCasinoReport": 582,
	"./leagues/reports/casinoReport/recordCasinoReport.js": 582,
	"./leagues/reports/casinoReport/recordTableCasinoReport": 1577,
	"./leagues/reports/casinoReport/recordTableCasinoReport.js": 1577,
	"./leagues/reports/casinoReport/tableCasinoReport": 580,
	"./leagues/reports/casinoReport/tableCasinoReport.js": 580,
	"./leagues/reports/userAfilliatesReport": 1578,
	"./leagues/reports/userAfilliatesReport.js": 1578,
	"./leagues/reports/user_affiliates/detailsReports": 1579,
	"./leagues/reports/user_affiliates/detailsReports.js": 1579,
	"./leagues/reports/user_affiliates/filterReports": 583,
	"./leagues/reports/user_affiliates/filterReports.js": 583,
	"./leagues/reports/user_affiliates/recordReports": 1580,
	"./leagues/reports/user_affiliates/recordReports.js": 1580,
	"./leagues/reports/user_affiliates/recordTableReports": 1581,
	"./leagues/reports/user_affiliates/recordTableReports.js": 1581,
	"./leagues/reports/user_affiliates/tableReports": 584,
	"./leagues/reports/user_affiliates/tableReports.js": 584,
	"./leagues/results/recordTableResponts": 575,
	"./leagues/results/recordTableResponts.js": 575,
	"./leagues/results/tableResults": 117,
	"./leagues/results/tableResults.js": 117,
	"./leagues/statistics": 1582,
	"./leagues/statistics.js": 1582,
	"./leagues/statistics/age": 588,
	"./leagues/statistics/age.js": 588,
	"./leagues/statistics/marketing": 586,
	"./leagues/statistics/marketing.js": 586,
	"./leagues/statistics/marketingvsregistros": 587,
	"./leagues/statistics/marketingvsregistros.js": 587,
	"./leagues/statistics/money": 585,
	"./leagues/statistics/money.js": 585,
	"./limitationsReport": 1583,
	"./limitationsReport.js": 1583,
	"./loading": 1584,
	"./loading.js": 1584,
	"./login": 1585,
	"./login.js": 1585,
	"./logsUserGeneral": 1586,
	"./logsUserGeneral.js": 1586,
	"./loteryReport": 1587,
	"./loteryReport.js": 1587,
	"./loyaltyLevelChangeHistory": 1588,
	"./loyaltyLevelChangeHistory.js": 1588,
	"./machine/AddMachineRegister": 1589,
	"./machine/AddMachineRegister.js": 1589,
	"./machine/addMachineManagement": 1590,
	"./machine/addMachineManagement.js": 1590,
	"./machine/cashier/advertising": 598,
	"./machine/cashier/advertising.js": 598,
	"./machine/cashier/cashier": 1591,
	"./machine/cashier/cashier.js": 1591,
	"./machine/cashier/tableAdvertising": 599,
	"./machine/cashier/tableAdvertising.js": 599,
	"./machine/configuration": 1592,
	"./machine/configuration.js": 1592,
	"./machine/configuration/changePassword": 1593,
	"./machine/configuration/changePassword.js": 1593,
	"./machine/configuration/changePassword/changePasswordView": 1594,
	"./machine/configuration/changePassword/changePasswordView.js": 1594,
	"./machine/configuration/generateToken": 1595,
	"./machine/configuration/generateToken.js": 1595,
	"./machine/configuration/generateToken/filter": 1596,
	"./machine/configuration/generateToken/filter.js": 1596,
	"./machine/configuration/generateToken/table": 1597,
	"./machine/configuration/generateToken/table.js": 1597,
	"./machine/configuration/qrgoogle": 1598,
	"./machine/configuration/qrgoogle.js": 1598,
	"./machine/configuration/securityChanges": 1599,
	"./machine/configuration/securityChanges.js": 1599,
	"./machine/configuration/securityChanges/filter": 1033,
	"./machine/configuration/securityChanges/filter.js": 1033,
	"./machine/configuration/securityChanges/table": 600,
	"./machine/configuration/securityChanges/table.js": 600,
	"./machine/filter": 601,
	"./machine/filter.js": 601,
	"./machine/information": 1600,
	"./machine/information.js": 1600,
	"./machine/machineManagement": 1601,
	"./machine/machineManagement.js": 1601,
	"./machine/machineRegister": 1602,
	"./machine/machineRegister.js": 1602,
	"./machine/managePointsGraphics": 1603,
	"./machine/managePointsGraphics.js": 1603,
	"./machine/pagoNotaCobro": 1604,
	"./machine/pagoNotaCobro.js": 1604,
	"./machine/pagoNotaCobro/PagoNotaCobro": 1034,
	"./machine/pagoNotaCobro/PagoNotaCobro.js": 1034,
	"./machine/pagoNotaCobro/filterPagoNotaCobro": 605,
	"./machine/pagoNotaCobro/filterPagoNotaCobro.js": 605,
	"./machine/pagoNotaCobro/tablePagoNotaCobro": 606,
	"./machine/pagoNotaCobro/tablePagoNotaCobro.js": 606,
	"./machine/pagoPremioMaquina": 1605,
	"./machine/pagoPremioMaquina.js": 1605,
	"./machine/pagopremio/PagoPremio": 608,
	"./machine/pagopremio/PagoPremio.js": 608,
	"./machine/pagopremio/detailsPagoPremio": 610,
	"./machine/pagopremio/detailsPagoPremio.js": 610,
	"./machine/pagopremio/filterPagoPremio": 607,
	"./machine/pagopremio/filterPagoPremio.js": 607,
	"./machine/pagopremio/recordPagoPremio": 611,
	"./machine/pagopremio/recordPagoPremio.js": 611,
	"./machine/pagopremio/recordTablePagoPremio": 1606,
	"./machine/pagopremio/recordTablePagoPremio.js": 1606,
	"./machine/pagopremio/tablePagoPremio": 609,
	"./machine/pagopremio/tablePagoPremio.js": 609,
	"./machine/pointsGraphics/filter": 603,
	"./machine/pointsGraphics/filter.js": 603,
	"./machine/pointsGraphics/pointsList": 604,
	"./machine/pointsGraphics/pointsList.js": 604,
	"./machine/products2": 1607,
	"./machine/products2.js": 1607,
	"./machine/products2/categories-products/filter": 612,
	"./machine/products2/categories-products/filter.js": 612,
	"./machine/products2/categories-products/table": 613,
	"./machine/products2/categories-products/table.js": 613,
	"./machine/products2/categoriesProducts": 1608,
	"./machine/products2/categoriesProducts.js": 1608,
	"./machine/products2/partners-games/filter": 614,
	"./machine/products2/partners-games/filter.js": 614,
	"./machine/products2/partners-games/table": 615,
	"./machine/products2/partners-games/table.js": 615,
	"./machine/products2/partners-products/filter": 616,
	"./machine/products2/partners-products/filter.js": 616,
	"./machine/products2/partners-products/table": 617,
	"./machine/products2/partners-products/table.js": 617,
	"./machine/products2/partners-providers/filter": 618,
	"./machine/products2/partners-providers/filter.js": 618,
	"./machine/products2/partners-providers/table": 619,
	"./machine/products2/partners-providers/table.js": 619,
	"./machine/products2/partners-subProviders/filter": 620,
	"./machine/products2/partners-subProviders/filter.js": 620,
	"./machine/products2/partners-subProviders/table": 621,
	"./machine/products2/partners-subProviders/table.js": 621,
	"./machine/products2/partners-tipoproducto/filter": 622,
	"./machine/products2/partners-tipoproducto/filter.js": 622,
	"./machine/products2/partners-tipoproducto/table": 623,
	"./machine/products2/partners-tipoproducto/table.js": 623,
	"./machine/products2/partnersGames": 1609,
	"./machine/products2/partnersGames.js": 1609,
	"./machine/products2/partnersProducts": 1610,
	"./machine/products2/partnersProducts.js": 1610,
	"./machine/products2/partnersProviders": 1611,
	"./machine/products2/partnersProviders.js": 1611,
	"./machine/products2/partnersSubProviders": 1612,
	"./machine/products2/partnersSubProviders.js": 1612,
	"./machine/products2/partnersTypeProduct": 1613,
	"./machine/products2/partnersTypeProduct.js": 1613,
	"./machine/reports": 1614,
	"./machine/reports.js": 1614,
	"./machine/reports/betsReport": 1615,
	"./machine/reports/betsReport.js": 1615,
	"./machine/reports/betsReport/detailsReport": 1616,
	"./machine/reports/betsReport/detailsReport.js": 1616,
	"./machine/reports/betsReport/filterReport": 624,
	"./machine/reports/betsReport/filterReport.js": 624,
	"./machine/reports/betsReport/recordReport": 1617,
	"./machine/reports/betsReport/recordReport.js": 1617,
	"./machine/reports/betsReport/recordTableReport": 1618,
	"./machine/reports/betsReport/recordTableReport.js": 1618,
	"./machine/reports/betsReport/recordTableTransReport": 1619,
	"./machine/reports/betsReport/recordTableTransReport.js": 1619,
	"./machine/reports/betsReport/recordTransReport": 626,
	"./machine/reports/betsReport/recordTransReport.js": 626,
	"./machine/reports/betsReport/tableReport": 625,
	"./machine/reports/betsReport/tableReport.js": 625,
	"./machine/reports/casinoGamesReport": 1620,
	"./machine/reports/casinoGamesReport.js": 1620,
	"./machine/reports/casinoReport/detailsCasinoReport": 629,
	"./machine/reports/casinoReport/detailsCasinoReport.js": 629,
	"./machine/reports/casinoReport/filterCasinoReport": 627,
	"./machine/reports/casinoReport/filterCasinoReport.js": 627,
	"./machine/reports/casinoReport/recordCasinoReport": 630,
	"./machine/reports/casinoReport/recordCasinoReport.js": 630,
	"./machine/reports/casinoReport/recordTableCasinoReport": 1621,
	"./machine/reports/casinoReport/recordTableCasinoReport.js": 1621,
	"./machine/reports/casinoReport/tableCasinoReport": 628,
	"./machine/reports/casinoReport/tableCasinoReport.js": 628,
	"./machine/reports/depositReport": 1622,
	"./machine/reports/depositReport.js": 1622,
	"./machine/reports/deposit_report/detailsDepositReports": 1035,
	"./machine/reports/deposit_report/detailsDepositReports.js": 1035,
	"./machine/reports/deposit_report/filterDepositReports": 631,
	"./machine/reports/deposit_report/filterDepositReports.js": 631,
	"./machine/reports/deposit_report/recordDepositReports": 633,
	"./machine/reports/deposit_report/recordDepositReports.js": 633,
	"./machine/reports/deposit_report/recordTableDepositReports": 1623,
	"./machine/reports/deposit_report/recordTableDepositReports.js": 1623,
	"./machine/reports/deposit_report/tableDepositReports": 632,
	"./machine/reports/deposit_report/tableDepositReports.js": 632,
	"./machine/reports/flujoCaja": 1624,
	"./machine/reports/flujoCaja.js": 1624,
	"./machine/reports/flujocaja/detailsFlujoCaja": 636,
	"./machine/reports/flujocaja/detailsFlujoCaja.js": 636,
	"./machine/reports/flujocaja/filterFlujoCaja": 634,
	"./machine/reports/flujocaja/filterFlujoCaja.js": 634,
	"./machine/reports/flujocaja/recordFlujoCaja": 637,
	"./machine/reports/flujocaja/recordFlujoCaja.js": 637,
	"./machine/reports/flujocaja/recordTableFlujoCaja": 1625,
	"./machine/reports/flujocaja/recordTableFlujoCaja.js": 1625,
	"./machine/reports/flujocaja/tableFlujoCaja": 635,
	"./machine/reports/flujocaja/tableFlujoCaja.js": 635,
	"./machine/reports/log/log": 638,
	"./machine/reports/log/log.js": 638,
	"./machine/reports/logReport": 1626,
	"./machine/reports/logReport.js": 1626,
	"./machine/reports/updates/filter": 639,
	"./machine/reports/updates/filter.js": 639,
	"./machine/reports/updates/table": 640,
	"./machine/reports/updates/table.js": 640,
	"./machine/reports/updatesReport": 1627,
	"./machine/reports/updatesReport.js": 1627,
	"./machine/reports/userAfilliatesReport": 1628,
	"./machine/reports/userAfilliatesReport.js": 1628,
	"./machine/reports/user_affiliates/detailsReports": 1629,
	"./machine/reports/user_affiliates/detailsReports.js": 1629,
	"./machine/reports/user_affiliates/filterReports": 641,
	"./machine/reports/user_affiliates/filterReports.js": 641,
	"./machine/reports/user_affiliates/recordReports": 1630,
	"./machine/reports/user_affiliates/recordReports.js": 1630,
	"./machine/reports/user_affiliates/recordTableReports": 1631,
	"./machine/reports/user_affiliates/recordTableReports.js": 1631,
	"./machine/reports/user_affiliates/tableReports": 642,
	"./machine/reports/user_affiliates/tableReports.js": 642,
	"./machine/reports/withdrawalRequests": 1632,
	"./machine/reports/withdrawalRequests.js": 1632,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests": 645,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests.js": 645,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest": 643,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest.js": 643,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest": 1633,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest.js": 1633,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest": 646,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest.js": 646,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest": 644,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest.js": 644,
	"./machine/results/recordTableResponts": 1634,
	"./machine/results/recordTableResponts.js": 1634,
	"./machine/results/tableResults": 1635,
	"./machine/results/tableResults.js": 1635,
	"./machine/statistics": 1636,
	"./machine/statistics.js": 1636,
	"./machine/statistics/age": 650,
	"./machine/statistics/age.js": 650,
	"./machine/statistics/marketing": 648,
	"./machine/statistics/marketing.js": 648,
	"./machine/statistics/marketingvsregistros": 649,
	"./machine/statistics/marketingvsregistros.js": 649,
	"./machine/statistics/money": 647,
	"./machine/statistics/money.js": 647,
	"./machine/table": 602,
	"./machine/table.js": 602,
	"./management/activateRegistration/filter": 205,
	"./management/activateRegistration/filter.js": 205,
	"./management/activateRegistration/response": 206,
	"./management/activateRegistration/response.js": 206,
	"./management/coupons/coupons": 450,
	"./management/coupons/coupons.js": 450,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw": 515,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw.js": 515,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw": 514,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw.js": 514,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw": 517,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw.js": 517,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw": 516,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw.js": 516,
	"./management/faltan.txt": 1966,
	"./management/managementClaims/filter": 651,
	"./management/managementClaims/filter.js": 651,
	"./management/managementClaims/table": 652,
	"./management/managementClaims/table.js": 652,
	"./management/managementContact/details": 163,
	"./management/managementContact/details.js": 163,
	"./management/managementContact/detailsTable": 653,
	"./management/managementContact/detailsTable.js": 653,
	"./management/managementContact/filterManagementContact": 654,
	"./management/managementContact/filterManagementContact.js": 654,
	"./management/managementContact/tableManagementContact": 655,
	"./management/managementContact/tableManagementContact.js": 655,
	"./management/managementContactUser/filter": 656,
	"./management/managementContactUser/filter.js": 656,
	"./management/managementContactUser/table": 657,
	"./management/managementContactUser/table.js": 657,
	"./management/managementGenericForms/filter": 658,
	"./management/managementGenericForms/filter.js": 658,
	"./management/managementGenericForms/table": 659,
	"./management/managementGenericForms/table.js": 659,
	"./management/quotaRetraction/Retraction": 660,
	"./management/quotaRetraction/Retraction.js": 660,
	"./management/quotaRetraction/search": 1036,
	"./management/quotaRetraction/search.js": 1036,
	"./management/registerFast/filterRegisterFast": 661,
	"./management/registerFast/filterRegisterFast.js": 661,
	"./management/registerFast/tableRegisterFast": 662,
	"./management/registerFast/tableRegisterFast.js": 662,
	"./management/reprintCheck/filterReprintCheck": 663,
	"./management/reprintCheck/filterReprintCheck.js": 663,
	"./management/reprintCheck/tableReprintCheck": 664,
	"./management/reprintCheck/tableReprintCheck.js": 664,
	"./management/restrictUser/filter": 665,
	"./management/restrictUser/filter.js": 665,
	"./management/restrictUser/table": 666,
	"./management/restrictUser/table.js": 666,
	"./management/reversionReload/filterReversionReload": 667,
	"./management/reversionReload/filterReversionReload.js": 667,
	"./management/reversionReload/tableReversionReload": 668,
	"./management/reversionReload/tableReversionReload.js": 668,
	"./management/usersVerification/information": 118,
	"./management/usersVerification/information.js": 118,
	"./management/usersVerification/informationJumio": 669,
	"./management/usersVerification/informationJumio.js": 669,
	"./managementClaims": 1637,
	"./managementClaims.js": 1637,
	"./managementContact": 1638,
	"./managementContact.js": 1638,
	"./managementContactUser": 1639,
	"./managementContactUser.js": 1639,
	"./managementGenericForms": 1640,
	"./managementGenericForms.js": 1640,
	"./menu": 11,
	"./menu.js": 11,
	"./menuBonus": 1641,
	"./menuBonus.js": 1641,
	"./menuBuilder": 1642,
	"./menuBuilder.js": 1642,
	"./menuMarketing": 1643,
	"./menuMarketing.js": 1643,
	"./menus": 1644,
	"./menus.js": 1644,
	"./messages/bannerInvasive": 1645,
	"./messages/bannerInvasive.js": 1645,
	"./messages/bannerInvasive/filter": 672,
	"./messages/bannerInvasive/filter.js": 672,
	"./messages/bannerInvasive/table": 673,
	"./messages/bannerInvasive/table.js": 673,
	"./messages/fringe": 1646,
	"./messages/fringe.js": 1646,
	"./messages/fringe/filter": 674,
	"./messages/fringe/filter.js": 674,
	"./messages/fringe/table": 675,
	"./messages/fringe/table.js": 675,
	"./messages/messageIntern/filter": 119,
	"./messages/messageIntern/filter.js": 119,
	"./messages/messageIntern/table": 120,
	"./messages/messageIntern/table.js": 120,
	"./messages/messageInternAgent/filter": 676,
	"./messages/messageInternAgent/filter.js": 676,
	"./messages/messageInternAgent/table": 677,
	"./messages/messageInternAgent/table.js": 677,
	"./messages/messageInternal": 1647,
	"./messages/messageInternal.js": 1647,
	"./messages/messageInternalAgent": 1648,
	"./messages/messageInternalAgent.js": 1648,
	"./messages/messageList": 1649,
	"./messages/messageList.js": 1649,
	"./messages/popup": 1650,
	"./messages/popup.js": 1650,
	"./messages/popup/filter": 678,
	"./messages/popup/filter.js": 678,
	"./messages/popup/table": 679,
	"./messages/popup/table.js": 679,
	"./messagesOld/messageIntern/filter": 1651,
	"./messagesOld/messageIntern/filter.js": 1651,
	"./messagesOld/messageIntern/table": 1652,
	"./messagesOld/messageIntern/table.js": 1652,
	"./messagesOld/messageList": 1653,
	"./messagesOld/messageList.js": 1653,
	"./myComissionsReport": 1654,
	"./myComissionsReport.js": 1654,
	"./myConfiguration/changeMyPassword": 1655,
	"./myConfiguration/changeMyPassword.js": 1655,
	"./myConfiguration/myInfoBetShop": 1656,
	"./myConfiguration/myInfoBetShop.js": 1656,
	"./myConfiguration/myInfoCustomer": 1657,
	"./myConfiguration/myInfoCustomer.js": 1657,
	"./myConfiguration/myInformation": 1658,
	"./myConfiguration/myInformation.js": 1658,
	"./myConfiguration/qrgoogle": 1659,
	"./myConfiguration/qrgoogle.js": 1659,
	"./notesUser": 1660,
	"./notesUser.js": 1660,
	"./notifications": 1007,
	"./notifications.js": 1007,
	"./operatorResponsibility": 1661,
	"./operatorResponsibility.js": 1661,
	"./ownersIncome": 1662,
	"./ownersIncome.js": 1662,
	"./ownersIncomeSecondLevel": 1663,
	"./ownersIncomeSecondLevel.js": 1663,
	"./pagoNotaRetiro": 1664,
	"./pagoNotaRetiro.js": 1664,
	"./pagoPremio": 1665,
	"./pagoPremio.js": 1665,
	"./pagoPremioVirtuales": 1666,
	"./pagoPremioVirtuales.js": 1666,
	"./paidPendingAwards": 1667,
	"./paidPendingAwards.js": 1667,
	"./partner/PartnerSettings": 1668,
	"./partner/PartnerSettings.js": 1668,
	"./partner/PartnerSettingsOld": 1669,
	"./partner/PartnerSettingsOld.js": 1669,
	"./partner/TRM": 1670,
	"./partner/TRM.js": 1670,
	"./partner/TRM/filter": 694,
	"./partner/TRM/filter.js": 694,
	"./partner/TRM/table": 695,
	"./partner/TRM/table.js": 695,
	"./partner/configuration": 1671,
	"./partner/configuration.js": 1671,
	"./partner/configuration/filter": 121,
	"./partner/configuration/filter.js": 121,
	"./partner/configuration/settings": 122,
	"./partner/configuration/settings.js": 122,
	"./partner/configurationControl": 1672,
	"./partner/configurationControl.js": 1672,
	"./partner/configurationControl/filter": 696,
	"./partner/configurationControl/filter.js": 696,
	"./partner/configurationControl/table": 697,
	"./partner/configurationControl/table.js": 697,
	"./partner/configurationControl2": 1673,
	"./partner/configurationControl2.js": 1673,
	"./partner/configurationControl2/filter": 698,
	"./partner/configurationControl2/filter.js": 698,
	"./partner/configurationControl2/table": 699,
	"./partner/configurationControl2/table.js": 699,
	"./partner/configurationOld/filter": 1674,
	"./partner/configurationOld/filter.js": 1674,
	"./partner/configurationOld/settings": 1675,
	"./partner/configurationOld/settings.js": 1675,
	"./partner/configurationSEO": 1676,
	"./partner/configurationSEO.js": 1676,
	"./partner/configurationSEO/filter": 700,
	"./partner/configurationSEO/filter.js": 700,
	"./partner/configurationSEO/settings": 701,
	"./partner/configurationSEO/settings.js": 701,
	"./partner/countries": 1677,
	"./partner/countries.js": 1677,
	"./partner/countries/countries": 702,
	"./partner/countries/countries.js": 702,
	"./partner/menusUser": 1678,
	"./partner/menusUser.js": 1678,
	"./partner/menusUser/filter": 703,
	"./partner/menusUser/filter.js": 703,
	"./partner/menusUser/table": 704,
	"./partner/menusUser/table.js": 704,
	"./partner/partner-list/filter": 692,
	"./partner/partner-list/filter.js": 692,
	"./partner/partner-list/table": 693,
	"./partner/partner-list/table.js": 693,
	"./partner/partnertManagement": 1679,
	"./partner/partnertManagement.js": 1679,
	"./partner/products": 1680,
	"./partner/products.js": 1680,
	"./partner/products/categories-products/filter": 705,
	"./partner/products/categories-products/filter.js": 705,
	"./partner/products/categories-products/table": 706,
	"./partner/products/categories-products/table.js": 706,
	"./partner/products/categoriesProducts": 1681,
	"./partner/products/categoriesProducts.js": 1681,
	"./partner/products/partners-products/filter": 707,
	"./partner/products/partners-products/filter.js": 707,
	"./partner/products/partners-products/table": 708,
	"./partner/products/partners-products/table.js": 708,
	"./partner/products/partners-providers/filter": 709,
	"./partner/products/partners-providers/filter.js": 709,
	"./partner/products/partners-providers/table": 710,
	"./partner/products/partners-providers/table.js": 710,
	"./partner/products/partners-subProviders/filter": 711,
	"./partner/products/partners-subProviders/filter.js": 711,
	"./partner/products/partners-subProviders/table": 712,
	"./partner/products/partners-subProviders/table.js": 712,
	"./partner/products/partners-tipoproducto/filter": 713,
	"./partner/products/partners-tipoproducto/filter.js": 713,
	"./partner/products/partners-tipoproducto/table": 714,
	"./partner/products/partners-tipoproducto/table.js": 714,
	"./partner/products/partnersProducts": 1682,
	"./partner/products/partnersProducts.js": 1682,
	"./partner/products/partnersProviders": 1683,
	"./partner/products/partnersProviders.js": 1683,
	"./partner/products/partnersSubProviders": 1684,
	"./partner/products/partnersSubProviders.js": 1684,
	"./partner/products/partnersTypeProduct": 1685,
	"./partner/products/partnersTypeProduct.js": 1685,
	"./partner/products/products-banks/filter": 715,
	"./partner/products/products-banks/filter.js": 715,
	"./partner/products/products-banks/table": 716,
	"./partner/products/products-banks/table.js": 716,
	"./partner/products/products-cryptoNetwork/filter": 717,
	"./partner/products/products-cryptoNetwork/filter.js": 717,
	"./partner/products/products-cryptoNetwork/table": 718,
	"./partner/products/products-cryptoNetwork/table.js": 718,
	"./partner/products/products-franchises/filter": 719,
	"./partner/products/products-franchises/filter.js": 719,
	"./partner/products/products-franchises/table": 720,
	"./partner/products/products-franchises/table.js": 720,
	"./partner/products/productsBanks": 1686,
	"./partner/products/productsBanks.js": 1686,
	"./partner/products/productsCryptoNetwork": 1687,
	"./partner/products/productsCryptoNetwork.js": 1687,
	"./partner/products/productsFranchises": 1688,
	"./partner/products/productsFranchises.js": 1688,
	"./partner/products2": 1689,
	"./partner/products2.js": 1689,
	"./partner/products2/banks-partners/filter": 721,
	"./partner/products2/banks-partners/filter.js": 721,
	"./partner/products2/banks-partners/table": 722,
	"./partner/products2/banks-partners/table.js": 722,
	"./partner/products2/categories-products/filter": 723,
	"./partner/products2/categories-products/filter.js": 723,
	"./partner/products2/categories-products/table": 724,
	"./partner/products2/categories-products/table.js": 724,
	"./partner/products2/categoriesProducts": 1690,
	"./partner/products2/categoriesProducts.js": 1690,
	"./partner/products2/enablement-products/filter": 725,
	"./partner/products2/enablement-products/filter.js": 725,
	"./partner/products2/enablement-products/table": 726,
	"./partner/products2/enablement-products/table.js": 726,
	"./partner/products2/enablementProducts": 1691,
	"./partner/products2/enablementProducts.js": 1691,
	"./partner/products2/franchises-partner/filter": 727,
	"./partner/products2/franchises-partner/filter.js": 727,
	"./partner/products2/franchises-partner/table": 728,
	"./partner/products2/franchises-partner/table.js": 728,
	"./partner/products2/partners-categories/filter": 729,
	"./partner/products2/partners-categories/filter.js": 729,
	"./partner/products2/partners-categories/table": 730,
	"./partner/products2/partners-categories/table.js": 730,
	"./partner/products2/partners-credentialsSubProviders/filter": 731,
	"./partner/products2/partners-credentialsSubProviders/filter.js": 731,
	"./partner/products2/partners-credentialsSubProviders/table": 732,
	"./partner/products2/partners-credentialsSubProviders/table.js": 732,
	"./partner/products2/partners-games/filter": 733,
	"./partner/products2/partners-games/filter.js": 733,
	"./partner/products2/partners-games/table": 734,
	"./partner/products2/partners-games/table.js": 734,
	"./partner/products2/partners-products/filter": 735,
	"./partner/products2/partners-products/filter.js": 735,
	"./partner/products2/partners-products/table": 736,
	"./partner/products2/partners-products/table.js": 736,
	"./partner/products2/partners-providers-order/filter": 1692,
	"./partner/products2/partners-providers-order/filter.js": 1692,
	"./partner/products2/partners-providers-order/table": 1693,
	"./partner/products2/partners-providers-order/table.js": 1693,
	"./partner/products2/partners-providers/filter": 737,
	"./partner/products2/partners-providers/filter.js": 737,
	"./partner/products2/partners-providers/table": 738,
	"./partner/products2/partners-providers/table.js": 738,
	"./partner/products2/partners-subProviders-order/filter": 739,
	"./partner/products2/partners-subProviders-order/filter.js": 739,
	"./partner/products2/partners-subProviders-order/table": 740,
	"./partner/products2/partners-subProviders-order/table.js": 740,
	"./partner/products2/partners-subProviders/filter": 741,
	"./partner/products2/partners-subProviders/filter.js": 741,
	"./partner/products2/partners-subProviders/table": 742,
	"./partner/products2/partners-subProviders/table.js": 742,
	"./partner/products2/partners-tipoproducto/filter": 743,
	"./partner/products2/partners-tipoproducto/filter.js": 743,
	"./partner/products2/partners-tipoproducto/table": 744,
	"./partner/products2/partners-tipoproducto/table.js": 744,
	"./partner/products2/partnersBanks": 1694,
	"./partner/products2/partnersBanks.js": 1694,
	"./partner/products2/partnersCategories": 1695,
	"./partner/products2/partnersCategories.js": 1695,
	"./partner/products2/partnersCredentialsSubProviders": 1696,
	"./partner/products2/partnersCredentialsSubProviders.js": 1696,
	"./partner/products2/partnersFranchises": 1697,
	"./partner/products2/partnersFranchises.js": 1697,
	"./partner/products2/partnersGames": 1698,
	"./partner/products2/partnersGames.js": 1698,
	"./partner/products2/partnersProducts": 1699,
	"./partner/products2/partnersProducts.js": 1699,
	"./partner/products2/partnersProviders": 1700,
	"./partner/products2/partnersProviders.js": 1700,
	"./partner/products2/partnersSubProviders": 1701,
	"./partner/products2/partnersSubProviders.js": 1701,
	"./partner/products2/partnersSubProvidersOrder": 1702,
	"./partner/products2/partnersSubProvidersOrder.js": 1702,
	"./partner/products2/partnersTypeProduct": 1703,
	"./partner/products2/partnersTypeProduct.js": 1703,
	"./partner/reports": 1704,
	"./partner/reports.js": 1704,
	"./partner/reports/autoexclusionUsers": 1705,
	"./partner/reports/autoexclusionUsers.js": 1705,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers": 747,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 747,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers": 745,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 745,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers": 1037,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1037,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 748,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 748,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers": 746,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 746,
	"./partner/reports/balanceAdjustments": 1706,
	"./partner/reports/balanceAdjustments.js": 1706,
	"./partner/reports/balanceAdjustments/filter": 749,
	"./partner/reports/balanceAdjustments/filter.js": 749,
	"./partner/reports/balanceAdjustments/table": 750,
	"./partner/reports/balanceAdjustments/table.js": 750,
	"./partner/reports/balanceHistory": 1707,
	"./partner/reports/balanceHistory.js": 1707,
	"./partner/reports/balanceHistory/filter": 751,
	"./partner/reports/balanceHistory/filter.js": 751,
	"./partner/reports/balanceHistory/table": 752,
	"./partner/reports/balanceHistory/table.js": 752,
	"./partner/reports/balanceHistoryBetShop": 1708,
	"./partner/reports/balanceHistoryBetShop.js": 1708,
	"./partner/reports/balanceHistoryBetShop/filter": 753,
	"./partner/reports/balanceHistoryBetShop/filter.js": 753,
	"./partner/reports/balanceHistoryBetShop/table": 754,
	"./partner/reports/balanceHistoryBetShop/table.js": 754,
	"./partner/reports/balanceUsers": 1709,
	"./partner/reports/balanceUsers.js": 1709,
	"./partner/reports/balanceUsers/filter": 755,
	"./partner/reports/balanceUsers/filter.js": 755,
	"./partner/reports/balanceUsers/record": 757,
	"./partner/reports/balanceUsers/record.js": 757,
	"./partner/reports/balanceUsers/resume": 758,
	"./partner/reports/balanceUsers/resume.js": 758,
	"./partner/reports/balanceUsers/table": 756,
	"./partner/reports/balanceUsers/table.js": 756,
	"./partner/reports/betsReport": 1710,
	"./partner/reports/betsReport.js": 1710,
	"./partner/reports/betsReport/detailsReport": 1711,
	"./partner/reports/betsReport/detailsReport.js": 1711,
	"./partner/reports/betsReport/filterReport": 759,
	"./partner/reports/betsReport/filterReport.js": 759,
	"./partner/reports/betsReport/recordReport": 763,
	"./partner/reports/betsReport/recordReport.js": 763,
	"./partner/reports/betsReport/recordTableReport": 764,
	"./partner/reports/betsReport/recordTableReport.js": 764,
	"./partner/reports/betsReport/recordTableTransReport": 762,
	"./partner/reports/betsReport/recordTableTransReport.js": 762,
	"./partner/reports/betsReport/recordTransReport": 761,
	"./partner/reports/betsReport/recordTransReport.js": 761,
	"./partner/reports/betsReport/tableReport": 760,
	"./partner/reports/betsReport/tableReport.js": 760,
	"./partner/reports/bonusReport": 1712,
	"./partner/reports/bonusReport.js": 1712,
	"./partner/reports/bonusReport/detailsBonusReport": 767,
	"./partner/reports/bonusReport/detailsBonusReport.js": 767,
	"./partner/reports/bonusReport/filterBonusReport": 765,
	"./partner/reports/bonusReport/filterBonusReport.js": 765,
	"./partner/reports/bonusReport/recordBonusReport": 768,
	"./partner/reports/bonusReport/recordBonusReport.js": 768,
	"./partner/reports/bonusReport/recordTableBonusReport": 769,
	"./partner/reports/bonusReport/recordTableBonusReport.js": 769,
	"./partner/reports/bonusReport/tableBonusReport": 766,
	"./partner/reports/bonusReport/tableBonusReport.js": 766,
	"./partner/reports/casinoGamesReport": 1713,
	"./partner/reports/casinoGamesReport.js": 1713,
	"./partner/reports/casinoReport/detailsCasinoReport": 772,
	"./partner/reports/casinoReport/detailsCasinoReport.js": 772,
	"./partner/reports/casinoReport/filterCasinoReport": 770,
	"./partner/reports/casinoReport/filterCasinoReport.js": 770,
	"./partner/reports/casinoReport/recordCasinoReport": 773,
	"./partner/reports/casinoReport/recordCasinoReport.js": 773,
	"./partner/reports/casinoReport/recordTableCasinoReport": 774,
	"./partner/reports/casinoReport/recordTableCasinoReport.js": 774,
	"./partner/reports/casinoReport/tableCasinoReport": 771,
	"./partner/reports/casinoReport/tableCasinoReport.js": 771,
	"./partner/reports/comissionsReport": 1714,
	"./partner/reports/comissionsReport.js": 1714,
	"./partner/reports/comissions_report/filter": 775,
	"./partner/reports/comissions_report/filter.js": 775,
	"./partner/reports/comissions_report/table": 776,
	"./partner/reports/comissions_report/table.js": 776,
	"./partner/reports/depositReport": 1715,
	"./partner/reports/depositReport.js": 1715,
	"./partner/reports/deposit_report/detailsDepositReports": 1038,
	"./partner/reports/deposit_report/detailsDepositReports.js": 1038,
	"./partner/reports/deposit_report/filterDepositReports": 777,
	"./partner/reports/deposit_report/filterDepositReports.js": 777,
	"./partner/reports/deposit_report/recordDepositReports": 779,
	"./partner/reports/deposit_report/recordDepositReports.js": 779,
	"./partner/reports/deposit_report/recordTableDepositReports": 780,
	"./partner/reports/deposit_report/recordTableDepositReports.js": 780,
	"./partner/reports/deposit_report/tableDepositReports": 778,
	"./partner/reports/deposit_report/tableDepositReports.js": 778,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido": 781,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 781,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido": 782,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido.js": 782,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido": 783,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido.js": 783,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido": 123,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 123,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido": 784,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido.js": 784,
	"./partner/reports/historicalCashFlow": 1716,
	"./partner/reports/historicalCashFlow.js": 1716,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow": 787,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow.js": 787,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow": 785,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow.js": 785,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow": 788,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow.js": 788,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow": 789,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 789,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow": 786,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow.js": 786,
	"./partner/reports/historyMovement": 1717,
	"./partner/reports/historyMovement.js": 1717,
	"./partner/reports/historyMovement/filter": 790,
	"./partner/reports/historyMovement/filter.js": 790,
	"./partner/reports/historyMovement/table": 791,
	"./partner/reports/historyMovement/table.js": 791,
	"./partner/reports/informeCasino/detailsInformeCasino": 1718,
	"./partner/reports/informeCasino/detailsInformeCasino.js": 1718,
	"./partner/reports/informeCasino/filterInformeCasino": 1719,
	"./partner/reports/informeCasino/filterInformeCasino.js": 1719,
	"./partner/reports/informeCasino/recordInformeCasino": 1720,
	"./partner/reports/informeCasino/recordInformeCasino.js": 1720,
	"./partner/reports/informeCasino/recordTableInformeCasino": 1721,
	"./partner/reports/informeCasino/recordTableInformeCasino.js": 1721,
	"./partner/reports/informeCasino/tableInformeCasino": 1722,
	"./partner/reports/informeCasino/tableInformeCasino.js": 1722,
	"./partner/reports/informeGerencial": 1723,
	"./partner/reports/informeGerencial.js": 1723,
	"./partner/reports/informeGerencial/detailsInformeGerencial": 794,
	"./partner/reports/informeGerencial/detailsInformeGerencial.js": 794,
	"./partner/reports/informeGerencial/filterInformeGerencial": 792,
	"./partner/reports/informeGerencial/filterInformeGerencial.js": 792,
	"./partner/reports/informeGerencial/recordInformeGerencial": 795,
	"./partner/reports/informeGerencial/recordInformeGerencial.js": 795,
	"./partner/reports/informeGerencial/recordTableInformeGerencial": 796,
	"./partner/reports/informeGerencial/recordTableInformeGerencial.js": 796,
	"./partner/reports/informeGerencial/tableInformeGerencial": 793,
	"./partner/reports/informeGerencial/tableInformeGerencial.js": 793,
	"./partner/reports/landingReport/detailsLandingReport": 1724,
	"./partner/reports/landingReport/detailsLandingReport.js": 1724,
	"./partner/reports/landingReport/filterLandingReport": 1725,
	"./partner/reports/landingReport/filterLandingReport.js": 1725,
	"./partner/reports/landingReport/recordLandingReport": 1726,
	"./partner/reports/landingReport/recordLandingReport.js": 1726,
	"./partner/reports/landingReport/recordTableLandingReport": 1727,
	"./partner/reports/landingReport/recordTableLandingReport.js": 1727,
	"./partner/reports/landingReport/tableLandingReport": 1728,
	"./partner/reports/landingReport/tableLandingReport.js": 1728,
	"./partner/reports/logsUser/filter": 1729,
	"./partner/reports/logsUser/filter.js": 1729,
	"./partner/reports/logsUser/table": 1730,
	"./partner/reports/logsUser/table.js": 1730,
	"./partner/reports/operatorResponsibility/filter": 1731,
	"./partner/reports/operatorResponsibility/filter.js": 1731,
	"./partner/reports/operatorResponsibility/table": 1732,
	"./partner/reports/operatorResponsibility/table.js": 1732,
	"./partner/reports/paidPendingAwards": 1733,
	"./partner/reports/paidPendingAwards.js": 1733,
	"./partner/reports/playersReport/detailsPlayersReport": 1734,
	"./partner/reports/playersReport/detailsPlayersReport.js": 1734,
	"./partner/reports/playersReport/filterPlayersReport": 1735,
	"./partner/reports/playersReport/filterPlayersReport.js": 1735,
	"./partner/reports/playersReport/recordPlayersReport": 1736,
	"./partner/reports/playersReport/recordPlayersReport.js": 1736,
	"./partner/reports/playersReport/recordTablePlayersReport": 800,
	"./partner/reports/playersReport/recordTablePlayersReport.js": 800,
	"./partner/reports/playersReport/tablePlayersReport": 1737,
	"./partner/reports/playersReport/tablePlayersReport.js": 1737,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1039,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1039,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar": 797,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 797,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1040,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1040,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 799,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 799,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar": 798,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 798,
	"./partner/reports/promotionalCodes/filter": 1738,
	"./partner/reports/promotionalCodes/filter.js": 1738,
	"./partner/reports/promotionalCodes/table": 1739,
	"./partner/reports/promotionalCodes/table.js": 1739,
	"./partner/reports/quotaRetraction/filter": 1740,
	"./partner/reports/quotaRetraction/filter.js": 1740,
	"./partner/reports/quotaRetraction/table": 1741,
	"./partner/reports/quotaRetraction/table.js": 1741,
	"./partner/reports/registeredDocument": 1742,
	"./partner/reports/registeredDocument.js": 1742,
	"./partner/reports/registeredDocuments/filter": 801,
	"./partner/reports/registeredDocuments/filter.js": 801,
	"./partner/reports/registeredDocuments/table": 802,
	"./partner/reports/registeredDocuments/table.js": 802,
	"./partner/reports/relationUserAggregator": 1743,
	"./partner/reports/relationUserAggregator.js": 1743,
	"./partner/reports/relationUserAggregator/filter": 803,
	"./partner/reports/relationUserAggregator/filter.js": 803,
	"./partner/reports/relationUserAggregator/table": 804,
	"./partner/reports/relationUserAggregator/table.js": 804,
	"./partner/reports/reportHash/filter": 1744,
	"./partner/reports/reportHash/filter.js": 1744,
	"./partner/reports/reportHash/table": 1745,
	"./partner/reports/reportHash/table.js": 1745,
	"./partner/reports/sessionsReport/detailsSessionsReport": 1746,
	"./partner/reports/sessionsReport/detailsSessionsReport.js": 1746,
	"./partner/reports/sessionsReport/filterSessionsReport": 1747,
	"./partner/reports/sessionsReport/filterSessionsReport.js": 1747,
	"./partner/reports/sessionsReport/recordSessionsReport": 1748,
	"./partner/reports/sessionsReport/recordSessionsReport.js": 1748,
	"./partner/reports/sessionsReport/recordTableSessionsReport": 1041,
	"./partner/reports/sessionsReport/recordTableSessionsReport.js": 1041,
	"./partner/reports/sessionsReport/tableSessionsReport": 1749,
	"./partner/reports/sessionsReport/tableSessionsReport.js": 1749,
	"./partner/reports/sportsTransactions": 1750,
	"./partner/reports/sportsTransactions.js": 1750,
	"./partner/reports/sportsTransactions/filter": 805,
	"./partner/reports/sportsTransactions/filter.js": 805,
	"./partner/reports/sportsTransactions/table": 806,
	"./partner/reports/sportsTransactions/table.js": 806,
	"./partner/reports/summaryCashFlow": 1751,
	"./partner/reports/summaryCashFlow.js": 1751,
	"./partner/reports/taxableEarnings/filter": 1752,
	"./partner/reports/taxableEarnings/filter.js": 1752,
	"./partner/reports/taxableEarnings/table": 1753,
	"./partner/reports/taxableEarnings/table.js": 1753,
	"./partner/reports/transfersReport/filter": 1754,
	"./partner/reports/transfersReport/filter.js": 1754,
	"./partner/reports/transfersReport/table": 1755,
	"./partner/reports/transfersReport/table.js": 1755,
	"./partner/reports/usuarioOnlineResumido": 1756,
	"./partner/reports/usuarioOnlineResumido.js": 1756,
	"./partner/reports/usuarioOnlineResumido/filter": 807,
	"./partner/reports/usuarioOnlineResumido/filter.js": 807,
	"./partner/reports/usuarioOnlineResumido/table": 808,
	"./partner/reports/usuarioOnlineResumido/table.js": 808,
	"./partner/reports/wallets": 1757,
	"./partner/reports/wallets.js": 1757,
	"./partner/reports/wallets/filter": 809,
	"./partner/reports/wallets/filter.js": 809,
	"./partner/reports/wallets/table": 810,
	"./partner/reports/wallets/table.js": 810,
	"./partner/templates": 1758,
	"./partner/templates.js": 1758,
	"./partner/templates/email": 1759,
	"./partner/templates/email.js": 1759,
	"./partner/templates/email/filter": 811,
	"./partner/templates/email/filter.js": 811,
	"./partner/templates/email/table": 812,
	"./partner/templates/email/table.js": 812,
	"./partner/templates/email/template": 813,
	"./partner/templates/email/template.js": 813,
	"./partner/templates/emailTemplate": 1760,
	"./partner/templates/emailTemplate.js": 1760,
	"./partner/templates/pdf": 1761,
	"./partner/templates/pdf.js": 1761,
	"./partner/templates/pdf/filter": 814,
	"./partner/templates/pdf/filter.js": 814,
	"./partner/templates/pdf/table": 815,
	"./partner/templates/pdf/table.js": 815,
	"./partner/templates/pdf/template": 816,
	"./partner/templates/pdf/template.js": 816,
	"./partner/templates/pdfTemplate": 1762,
	"./partner/templates/pdfTemplate.js": 1762,
	"./partner/templates/sms": 1763,
	"./partner/templates/sms.js": 1763,
	"./partner/templates/sms/filter": 817,
	"./partner/templates/sms/filter.js": 817,
	"./partner/templates/sms/table": 818,
	"./partner/templates/sms/table.js": 818,
	"./partner/templates/sms/template": 819,
	"./partner/templates/sms/template.js": 819,
	"./partner/templates/smsTemplate": 1764,
	"./partner/templates/smsTemplate.js": 1764,
	"./partners": 1765,
	"./partners.js": 1765,
	"./partnersCategories": 1766,
	"./partnersCategories.js": 1766,
	"./partnersProducts": 1767,
	"./partnersProducts.js": 1767,
	"./partnersProductsCountry": 1768,
	"./partnersProductsCountry.js": 1768,
	"./partnersProviders": 1769,
	"./partnersProviders.js": 1769,
	"./partnersTypeProduct": 1770,
	"./partnersTypeProduct.js": 1770,
	"./payPrizesLoyalty": 1771,
	"./payPrizesLoyalty.js": 1771,
	"./payhistoryview": 1772,
	"./payhistoryview.js": 1772,
	"./platformSpecific": 1773,
	"./platformSpecific.js": 1773,
	"./platformSpecific2": 1774,
	"./platformSpecific2.js": 1774,
	"./playerAccount": 1775,
	"./playerAccount.js": 1775,
	"./playerAccount2": 1776,
	"./playerAccount2.js": 1776,
	"./players": 3,
	"./players.js": 3,
	"./playersList": 1777,
	"./playersList.js": 1777,
	"./playersList2": 1778,
	"./playersList2.js": 1778,
	"./playersListAggregator": 1779,
	"./playersListAggregator.js": 1779,
	"./playersLists": 1780,
	"./playersLists.js": 1780,
	"./playersReport": 1781,
	"./playersReport.js": 1781,
	"./pointSettings": 1782,
	"./pointSettings.js": 1782,
	"./pointsUsers": 1783,
	"./pointsUsers.js": 1783,
	"./pokerReport": 1784,
	"./pokerReport.js": 1784,
	"./prices": 1785,
	"./prices.js": 1785,
	"./prizesLoyalty": 1786,
	"./prizesLoyalty.js": 1786,
	"./products": 1787,
	"./products.js": 1787,
	"./products/activeProviders/filterActiveProviders": 207,
	"./products/activeProviders/filterActiveProviders.js": 207,
	"./products/activeProviders/tableActiveProviders": 208,
	"./products/activeProviders/tableActiveProviders.js": 208,
	"./products/banks/filterBanks": 325,
	"./products/banks/filterBanks.js": 325,
	"./products/banks/tableBanks": 326,
	"./products/banks/tableBanks.js": 326,
	"./products/blockchain-networks/filterBlockchainNetworks": 384,
	"./products/blockchain-networks/filterBlockchainNetworks.js": 384,
	"./products/blockchain-networks/tableBlockchainNetworks": 385,
	"./products/blockchain-networks/tableBlockchainNetworks.js": 385,
	"./products/categories-products/detailsCategoriesProducts": 1024,
	"./products/categories-products/detailsCategoriesProducts.js": 1024,
	"./products/categories-products/filterCategoriesProducts": 429,
	"./products/categories-products/filterCategoriesProducts.js": 429,
	"./products/categories-products/recordCategoriesProducts": 1025,
	"./products/categories-products/recordCategoriesProducts.js": 1025,
	"./products/categories-products/recordTableCategoriesProducts": 431,
	"./products/categories-products/recordTableCategoriesProducts.js": 431,
	"./products/categories-products/tableCategoriesProducts": 430,
	"./products/categories-products/tableCategoriesProducts.js": 430,
	"./products/categories/detailsCategories": 1022,
	"./products/categories/detailsCategories.js": 1022,
	"./products/categories/filterCategories": 426,
	"./products/categories/filterCategories.js": 426,
	"./products/categories/recordCategories": 1023,
	"./products/categories/recordCategories.js": 1023,
	"./products/categories/recordTableCategories": 428,
	"./products/categories/recordTableCategories.js": 428,
	"./products/categories/tableCategories": 427,
	"./products/categories/tableCategories.js": 427,
	"./products/crypto-blockchain/filterCryptoBlockchain": 453,
	"./products/crypto-blockchain/filterCryptoBlockchain.js": 453,
	"./products/crypto-blockchain/tableCryptoBlockchain": 454,
	"./products/crypto-blockchain/tableCryptoBlockchain.js": 454,
	"./products/cryptos/filterCrypto": 455,
	"./products/cryptos/filterCrypto.js": 455,
	"./products/cryptos/tableCrypto": 456,
	"./products/cryptos/tableCrypto.js": 456,
	"./products/franchises/filterFranchises": 524,
	"./products/franchises/filterFranchises.js": 524,
	"./products/franchises/tableFranchises": 525,
	"./products/franchises/tableFranchises.js": 525,
	"./products/partners-products-country/detailsPartnersProductsCountry": 830,
	"./products/partners-products-country/detailsPartnersProductsCountry.js": 830,
	"./products/partners-products-country/filterPartnersProductsCountry": 828,
	"./products/partners-products-country/filterPartnersProductsCountry.js": 828,
	"./products/partners-products-country/recordPartnersProductsCountry": 831,
	"./products/partners-products-country/recordPartnersProductsCountry.js": 831,
	"./products/partners-products-country/recordTablePartnersProductsCountry": 832,
	"./products/partners-products-country/recordTablePartnersProductsCountry.js": 832,
	"./products/partners-products-country/tablePartnersProductsCountry": 829,
	"./products/partners-products-country/tablePartnersProductsCountry.js": 829,
	"./products/partners-products/detailsPartnersProducts": 826,
	"./products/partners-products/detailsPartnersProducts.js": 826,
	"./products/partners-products/filterPartnersProducts": 824,
	"./products/partners-products/filterPartnersProducts.js": 824,
	"./products/partners-products/recordPartnersProducts": 827,
	"./products/partners-products/recordPartnersProducts.js": 827,
	"./products/partners-products/recordTablePartnersProducts": 32,
	"./products/partners-products/recordTablePartnersProducts.js": 32,
	"./products/partners-products/tablePartnersProducts": 825,
	"./products/partners-products/tablePartnersProducts.js": 825,
	"./products/partners-providers/details": 835,
	"./products/partners-providers/details.js": 835,
	"./products/partners-providers/filter": 833,
	"./products/partners-providers/filter.js": 833,
	"./products/partners-providers/record": 836,
	"./products/partners-providers/record.js": 836,
	"./products/partners-providers/recordTable": 1788,
	"./products/partners-providers/recordTable.js": 1788,
	"./products/partners-providers/table": 834,
	"./products/partners-providers/table.js": 834,
	"./products/partners-tipoproducto/details": 839,
	"./products/partners-tipoproducto/details.js": 839,
	"./products/partners-tipoproducto/filter": 837,
	"./products/partners-tipoproducto/filter.js": 837,
	"./products/partners-tipoproducto/record": 840,
	"./products/partners-tipoproducto/record.js": 840,
	"./products/partners-tipoproducto/recordTable": 1789,
	"./products/partners-tipoproducto/recordTable.js": 1789,
	"./products/partners-tipoproducto/table": 838,
	"./products/partners-tipoproducto/table.js": 838,
	"./products/partners/filter": 820,
	"./products/partners/filter.js": 820,
	"./products/partners/table": 821,
	"./products/partners/table.js": 821,
	"./products/products/detailsProducts": 1042,
	"./products/products/detailsProducts.js": 1042,
	"./products/products/filterProducts": 862,
	"./products/products/filterProducts.js": 862,
	"./products/products/recordProducts": 1043,
	"./products/products/recordProducts.js": 1043,
	"./products/products/recordTableProducts": 864,
	"./products/products/recordTableProducts.js": 864,
	"./products/products/tableProducts": 863,
	"./products/products/tableProducts.js": 863,
	"./products/providers/detailsProviders": 69,
	"./products/providers/detailsProviders.js": 69,
	"./products/providers/filterProviders": 865,
	"./products/providers/filterProviders.js": 865,
	"./products/providers/recordProviders": 70,
	"./products/providers/recordProviders.js": 70,
	"./products/providers/recordTableProviders": 327,
	"./products/providers/recordTableProviders.js": 327,
	"./products/providers/tableProviders": 866,
	"./products/providers/tableProviders.js": 866,
	"./products/subProviders/filter": 867,
	"./products/subProviders/filter.js": 867,
	"./products/subProviders/table": 868,
	"./products/subProviders/table.js": 868,
	"./products/tags/detailsTags": 1044,
	"./products/tags/detailsTags.js": 1044,
	"./products/tags/filterTags": 869,
	"./products/tags/filterTags.js": 869,
	"./products/tags/recordTableTags": 870,
	"./products/tags/recordTableTags.js": 870,
	"./products/tags/recordTags": 1045,
	"./products/tags/recordTags.js": 1045,
	"./products/tags/tableTags": 871,
	"./products/tags/tableTags.js": 871,
	"./profile": 1790,
	"./profile.js": 1790,
	"./profileOptions": 1791,
	"./profileOptions.js": 1791,
	"./profileOptions2": 1792,
	"./profileOptions2.js": 1792,
	"./profileOptionsOld": 1793,
	"./profileOptionsOld.js": 1793,
	"./promotionalCasinoCampaings": 1794,
	"./promotionalCasinoCampaings.js": 1794,
	"./promotionalCodes": 1795,
	"./promotionalCodes.js": 1795,
	"./promotionalSportbookCampaings": 1796,
	"./promotionalSportbookCampaings.js": 1796,
	"./providers": 1797,
	"./providers.js": 1797,
	"./qualifying": 1798,
	"./qualifying.js": 1798,
	"./quotaRetraction": 1799,
	"./quotaRetraction.js": 1799,
	"./quotaRetractionReport": 1800,
	"./quotaRetractionReport.js": 1800,
	"./recargarCredito": 1801,
	"./recargarCredito.js": 1801,
	"./recargarCreditoAgente": 1802,
	"./recargarCreditoAgente.js": 1802,
	"./referralsAwardsReport": 1803,
	"./referralsAwardsReport.js": 1803,
	"./referralsReport": 1804,
	"./referralsReport.js": 1804,
	"./registerFast": 1805,
	"./registerFast.js": 1805,
	"./registeredDocument": 1806,
	"./registeredDocument.js": 1806,
	"./registeredDocuments": 1807,
	"./registeredDocuments.js": 1807,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports": 442,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports.js": 442,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports": 443,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports.js": 443,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports": 444,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports.js": 444,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports": 445,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports.js": 445,
	"./regulations/futureEvents/filterFutureEventsReports": 526,
	"./regulations/futureEvents/filterFutureEventsReports.js": 526,
	"./regulations/futureEvents/tableFutureEventsReports": 527,
	"./regulations/futureEvents/tableFutureEventsReports.js": 527,
	"./regulations/gamesPerformance/filterGamesPerformanceReports": 528,
	"./regulations/gamesPerformance/filterGamesPerformanceReports.js": 528,
	"./regulations/gamesPerformance/tableGamesPerformanceReports": 529,
	"./regulations/gamesPerformance/tableGamesPerformanceReports.js": 529,
	"./regulations/getReportStructureGames/filterGetReportStructureGames": 530,
	"./regulations/getReportStructureGames/filterGetReportStructureGames.js": 530,
	"./regulations/getReportStructureGames/tableGetReportStructureGames": 531,
	"./regulations/getReportStructureGames/tableGetReportStructureGames.js": 531,
	"./regulations/jackpotPayment/filterJackpotPaymentReports": 557,
	"./regulations/jackpotPayment/filterJackpotPaymentReports.js": 557,
	"./regulations/jackpotPayment/tableJackpotPaymentReports": 558,
	"./regulations/jackpotPayment/tableJackpotPaymentReports.js": 558,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports": 559,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports.js": 559,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports": 560,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports.js": 560,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino": 561,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino.js": 561,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino": 562,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino.js": 562,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet": 563,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet.js": 563,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet": 564,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet.js": 564,
	"./regulations/ownersIncome/filterOwnersIncomeReports": 686,
	"./regulations/ownersIncome/filterOwnersIncomeReports.js": 686,
	"./regulations/ownersIncome/tableOwnersIncomeReports": 687,
	"./regulations/ownersIncome/tableOwnersIncomeReports.js": 687,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports": 688,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports.js": 688,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports": 689,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports.js": 689,
	"./regulations/platformSpecific/filterPlatformSpecificReports": 841,
	"./regulations/platformSpecific/filterPlatformSpecificReports.js": 841,
	"./regulations/platformSpecific/tablePlatformSpecificReports": 842,
	"./regulations/platformSpecific/tablePlatformSpecificReports.js": 842,
	"./regulations/platformSpecific2/filterPlatformSpecificReports": 843,
	"./regulations/platformSpecific2/filterPlatformSpecificReports.js": 843,
	"./regulations/platformSpecific2/tablePlatformSpecificReports": 844,
	"./regulations/platformSpecific2/tablePlatformSpecificReports.js": 844,
	"./regulations/playerAccount/filterPlayerAccountReports": 845,
	"./regulations/playerAccount/filterPlayerAccountReports.js": 845,
	"./regulations/playerAccount/tablePlayerAccountReports": 846,
	"./regulations/playerAccount/tablePlayerAccountReports.js": 846,
	"./regulations/playerAccount2/filterPlayerAccountReports": 847,
	"./regulations/playerAccount2/filterPlayerAccountReports.js": 847,
	"./regulations/playerAccount2/tablePlayerAccountReports": 848,
	"./regulations/playerAccount2/tablePlayerAccountReports.js": 848,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports": 896,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports.js": 896,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports": 897,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports.js": 897,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports": 898,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports.js": 898,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports": 899,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports.js": 899,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports": 900,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports.js": 900,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports": 901,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports.js": 901,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports": 902,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports.js": 902,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports": 903,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports.js": 903,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports": 904,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports.js": 904,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports": 905,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports.js": 905,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports": 906,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports.js": 906,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports": 907,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports.js": 907,
	"./relationUserAggregator": 1808,
	"./relationUserAggregator.js": 1808,
	"./reportHash": 1809,
	"./reportHash.js": 1809,
	"./reportMarketing": 1810,
	"./reportMarketing.js": 1810,
	"./reports/affiliatesBetShop/filter": 211,
	"./reports/affiliatesBetShop/filter.js": 211,
	"./reports/affiliatesBetShop/table": 212,
	"./reports/affiliatesBetShop/table.js": 212,
	"./reports/assignmentQuota/filter": 296,
	"./reports/assignmentQuota/filter.js": 296,
	"./reports/assignmentQuota/table": 297,
	"./reports/assignmentQuota/table.js": 297,
	"./reports/assignmentQuotaMade/filter": 294,
	"./reports/assignmentQuotaMade/filter.js": 294,
	"./reports/assignmentQuotaMade/table": 295,
	"./reports/assignmentQuotaMade/table.js": 295,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers": 300,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 300,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers": 298,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers.js": 298,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers": 301,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers.js": 301,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers": 29,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 29,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers": 299,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers.js": 299,
	"./reports/balanceAdjustments/filter": 302,
	"./reports/balanceAdjustments/filter.js": 302,
	"./reports/balanceAdjustments/table": 303,
	"./reports/balanceAdjustments/table.js": 303,
	"./reports/balanceHistory/filter": 304,
	"./reports/balanceHistory/filter.js": 304,
	"./reports/balanceHistory/table": 305,
	"./reports/balanceHistory/table.js": 305,
	"./reports/balanceHistory2/filter": 1811,
	"./reports/balanceHistory2/filter.js": 1811,
	"./reports/balanceHistory2/filter2": 306,
	"./reports/balanceHistory2/filter2.js": 306,
	"./reports/balanceHistory2/table": 1812,
	"./reports/balanceHistory2/table.js": 1812,
	"./reports/balanceHistory2/table2": 307,
	"./reports/balanceHistory2/table2.js": 307,
	"./reports/balanceHistoryBetShop/filter": 310,
	"./reports/balanceHistoryBetShop/filter.js": 310,
	"./reports/balanceHistoryBetShop/table": 311,
	"./reports/balanceHistoryBetShop/table.js": 311,
	"./reports/balanceHistoryBetShop2/filter": 1813,
	"./reports/balanceHistoryBetShop2/filter.js": 1813,
	"./reports/balanceHistoryBetShop2/filter2": 312,
	"./reports/balanceHistoryBetShop2/filter2.js": 312,
	"./reports/balanceHistoryBetShop2/table": 1814,
	"./reports/balanceHistoryBetShop2/table.js": 1814,
	"./reports/balanceHistoryBetShop2/table2": 313,
	"./reports/balanceHistoryBetShop2/table2.js": 313,
	"./reports/balanceHistoryForAdminUser/filter": 308,
	"./reports/balanceHistoryForAdminUser/filter.js": 308,
	"./reports/balanceHistoryForAdminUser/table": 309,
	"./reports/balanceHistoryForAdminUser/table.js": 309,
	"./reports/balanceHistoryForAgent/filter": 314,
	"./reports/balanceHistoryForAgent/filter.js": 314,
	"./reports/balanceHistoryForAgent/table": 315,
	"./reports/balanceHistoryForAgent/table.js": 315,
	"./reports/balanceHistoryForBetShop/filter": 316,
	"./reports/balanceHistoryForBetShop/filter.js": 316,
	"./reports/balanceHistoryForBetShop/table": 317,
	"./reports/balanceHistoryForBetShop/table.js": 317,
	"./reports/balanceHistoryMachine/filter": 318,
	"./reports/balanceHistoryMachine/filter.js": 318,
	"./reports/balanceHistoryMachine/table": 319,
	"./reports/balanceHistoryMachine/table.js": 319,
	"./reports/balanceUsers/filter": 320,
	"./reports/balanceUsers/filter.js": 320,
	"./reports/balanceUsers/record": 136,
	"./reports/balanceUsers/record.js": 136,
	"./reports/balanceUsers/resume": 322,
	"./reports/balanceUsers/resume.js": 322,
	"./reports/balanceUsers/table": 321,
	"./reports/balanceUsers/table.js": 321,
	"./reports/betsReport/detailsReport": 1815,
	"./reports/betsReport/detailsReport.js": 1815,
	"./reports/betsReport/filterReport": 93,
	"./reports/betsReport/filterReport.js": 93,
	"./reports/betsReport/recordReport": 72,
	"./reports/betsReport/recordReport.js": 72,
	"./reports/betsReport/recordTableReport": 24,
	"./reports/betsReport/recordTableReport.js": 24,
	"./reports/betsReport/recordTableTransReport": 39,
	"./reports/betsReport/recordTableTransReport.js": 39,
	"./reports/betsReport/recordTransReport": 95,
	"./reports/betsReport/recordTransReport.js": 95,
	"./reports/betsReport/tableReport": 94,
	"./reports/betsReport/tableReport.js": 94,
	"./reports/betsReportBetShop/detailsReport": 1816,
	"./reports/betsReportBetShop/detailsReport.js": 1816,
	"./reports/betsReportBetShop/filterReport": 378,
	"./reports/betsReportBetShop/filterReport.js": 378,
	"./reports/betsReportBetShop/recordReport": 381,
	"./reports/betsReportBetShop/recordReport.js": 381,
	"./reports/betsReportBetShop/recordTableReport": 1817,
	"./reports/betsReportBetShop/recordTableReport.js": 1817,
	"./reports/betsReportBetShop/recordTableTransReport": 1818,
	"./reports/betsReportBetShop/recordTableTransReport.js": 1818,
	"./reports/betsReportBetShop/recordTransReport": 380,
	"./reports/betsReportBetShop/recordTransReport.js": 380,
	"./reports/betsReportBetShop/tableReport": 379,
	"./reports/betsReportBetShop/tableReport.js": 379,
	"./reports/bonusReport/detailsBonusReport": 140,
	"./reports/bonusReport/detailsBonusReport.js": 140,
	"./reports/bonusReport/filterBonusReport": 386,
	"./reports/bonusReport/filterBonusReport.js": 386,
	"./reports/bonusReport/recordBonusReport": 141,
	"./reports/bonusReport/recordBonusReport.js": 141,
	"./reports/bonusReport/recordTableBonusReport": 18,
	"./reports/bonusReport/recordTableBonusReport.js": 18,
	"./reports/bonusReport/tableBonusReport": 387,
	"./reports/bonusReport/tableBonusReport.js": 387,
	"./reports/bonusReport2/detailsBonusReport": 142,
	"./reports/bonusReport2/detailsBonusReport.js": 142,
	"./reports/bonusReport2/filterBonusReport": 388,
	"./reports/bonusReport2/filterBonusReport.js": 388,
	"./reports/bonusReport2/recordBonusReport": 143,
	"./reports/bonusReport2/recordBonusReport.js": 143,
	"./reports/bonusReport2/recordTableBonusReport": 1819,
	"./reports/bonusReport2/recordTableBonusReport.js": 1819,
	"./reports/bonusReport2/tableBonusReport": 389,
	"./reports/bonusReport2/tableBonusReport.js": 389,
	"./reports/bonusReports2/filter": 390,
	"./reports/bonusReports2/filter.js": 390,
	"./reports/bonusReports2/table": 391,
	"./reports/bonusReports2/table.js": 391,
	"./reports/casinoReport/detailsCasinoReport": 144,
	"./reports/casinoReport/detailsCasinoReport.js": 144,
	"./reports/casinoReport/filterCasinoReport": 422,
	"./reports/casinoReport/filterCasinoReport.js": 422,
	"./reports/casinoReport/recordCasinoReport": 145,
	"./reports/casinoReport/recordCasinoReport.js": 145,
	"./reports/casinoReport/recordTableCasinoReport": 9,
	"./reports/casinoReport/recordTableCasinoReport.js": 9,
	"./reports/casinoReport/tableCasinoReport": 423,
	"./reports/casinoReport/tableCasinoReport.js": 423,
	"./reports/casinoReport2/detailsCasinoReport": 146,
	"./reports/casinoReport2/detailsCasinoReport.js": 146,
	"./reports/casinoReport2/filterCasinoReport": 1820,
	"./reports/casinoReport2/filterCasinoReport.js": 1820,
	"./reports/casinoReport2/filterCasinoReport2": 424,
	"./reports/casinoReport2/filterCasinoReport2.js": 424,
	"./reports/casinoReport2/recordCasinoReport": 147,
	"./reports/casinoReport2/recordCasinoReport.js": 147,
	"./reports/casinoReport2/recordTableCasinoReport": 1821,
	"./reports/casinoReport2/recordTableCasinoReport.js": 1821,
	"./reports/casinoReport2/tableCasinoReport": 1822,
	"./reports/casinoReport2/tableCasinoReport.js": 1822,
	"./reports/casinoReport2/tableCasinoReport2": 425,
	"./reports/casinoReport2/tableCasinoReport2.js": 425,
	"./reports/comissions_report/filter": 432,
	"./reports/comissions_report/filter.js": 432,
	"./reports/comissions_report/table": 433,
	"./reports/comissions_report/table.js": 433,
	"./reports/comissions_report2/filter": 434,
	"./reports/comissions_report2/filter.js": 434,
	"./reports/comissions_report2/table": 435,
	"./reports/comissions_report2/table.js": 435,
	"./reports/commisionsPay/filter": 436,
	"./reports/commisionsPay/filter.js": 436,
	"./reports/commisionsPay/table": 437,
	"./reports/commisionsPay/table.js": 437,
	"./reports/coupons_report/details": 1823,
	"./reports/coupons_report/details.js": 1823,
	"./reports/coupons_report/filter": 451,
	"./reports/coupons_report/filter.js": 451,
	"./reports/coupons_report/record": 148,
	"./reports/coupons_report/record.js": 148,
	"./reports/coupons_report/recordReports": 1824,
	"./reports/coupons_report/recordReports.js": 1824,
	"./reports/coupons_report/table": 452,
	"./reports/coupons_report/table.js": 452,
	"./reports/customReport/filter": 457,
	"./reports/customReport/filter.js": 457,
	"./reports/customReport/table": 458,
	"./reports/customReport/table.js": 458,
	"./reports/depositReport2/filter": 503,
	"./reports/depositReport2/filter.js": 503,
	"./reports/depositReport2/table": 504,
	"./reports/depositReport2/table.js": 504,
	"./reports/depositReportFranchise/filterDepositReportFranchise": 509,
	"./reports/depositReportFranchise/filterDepositReportFranchise.js": 509,
	"./reports/depositReportFranchise/tableDepositReportFranchise": 510,
	"./reports/depositReportFranchise/tableDepositReportFranchise.js": 510,
	"./reports/deposit_report/detailsDepositReports": 1030,
	"./reports/deposit_report/detailsDepositReports.js": 1030,
	"./reports/deposit_report/filterDepositReports": 501,
	"./reports/deposit_report/filterDepositReports.js": 501,
	"./reports/deposit_report/recordDepositReports": 151,
	"./reports/deposit_report/recordDepositReports.js": 151,
	"./reports/deposit_report/recordTableDepositReports": 10,
	"./reports/deposit_report/recordTableDepositReports.js": 10,
	"./reports/deposit_report/tableDepositReports": 502,
	"./reports/deposit_report/tableDepositReports.js": 502,
	"./reports/deposit_report_3/detailsDepositReports": 1031,
	"./reports/deposit_report_3/detailsDepositReports.js": 1031,
	"./reports/deposit_report_3/filterDepositReports": 505,
	"./reports/deposit_report_3/filterDepositReports.js": 505,
	"./reports/deposit_report_3/recordDepositReports": 152,
	"./reports/deposit_report_3/recordDepositReports.js": 152,
	"./reports/deposit_report_3/recordTableDepositReports": 1825,
	"./reports/deposit_report_3/recordTableDepositReports.js": 1825,
	"./reports/deposit_report_3/tableDepositReports": 506,
	"./reports/deposit_report_3/tableDepositReports.js": 506,
	"./reports/deposit_report_betshop/detailsDepositReports": 1032,
	"./reports/deposit_report_betshop/detailsDepositReports.js": 1032,
	"./reports/deposit_report_betshop/filterDepositReports": 507,
	"./reports/deposit_report_betshop/filterDepositReports.js": 507,
	"./reports/deposit_report_betshop/recordDepositReports": 153,
	"./reports/deposit_report_betshop/recordDepositReports.js": 153,
	"./reports/deposit_report_betshop/recordTableDepositReports": 1826,
	"./reports/deposit_report_betshop/recordTableDepositReports.js": 1826,
	"./reports/deposit_report_betshop/tableDepositReports": 508,
	"./reports/deposit_report_betshop/tableDepositReports.js": 508,
	"./reports/emailsReport/detailsEmailsReport": 155,
	"./reports/emailsReport/detailsEmailsReport.js": 155,
	"./reports/emailsReport/filterEmailsReport": 518,
	"./reports/emailsReport/filterEmailsReport.js": 518,
	"./reports/emailsReport/recordEmailsReport": 156,
	"./reports/emailsReport/recordEmailsReport.js": 156,
	"./reports/emailsReport/recordTableEmailsReport": 1827,
	"./reports/emailsReport/recordTableEmailsReport.js": 1827,
	"./reports/emailsReport/tableEmailsReport": 519,
	"./reports/emailsReport/tableEmailsReport.js": 519,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido": 914,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 914,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido": 915,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido.js": 915,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido": 916,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido.js": 916,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido": 31,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 31,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido": 917,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido.js": 917,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido": 918,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido.js": 918,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido": 1828,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido.js": 1828,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2": 919,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2.js": 919,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido": 920,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido.js": 920,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido": 1829,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido.js": 1829,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido": 1830,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido.js": 1830,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2": 921,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2.js": 921,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido": 922,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido.js": 922,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido": 923,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido.js": 923,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido": 924,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido.js": 924,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido": 1831,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido.js": 1831,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido": 925,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido.js": 925,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow": 534,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow.js": 534,
	"./reports/historicalCashFlow/filterHistoricalCashFlow": 532,
	"./reports/historicalCashFlow/filterHistoricalCashFlow.js": 532,
	"./reports/historicalCashFlow/recordHistoricalCashFlow": 535,
	"./reports/historicalCashFlow/recordHistoricalCashFlow.js": 535,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow": 536,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 536,
	"./reports/historicalCashFlow/tableHistoricalCashFlow": 533,
	"./reports/historicalCashFlow/tableHistoricalCashFlow.js": 533,
	"./reports/historyMovement/filter": 537,
	"./reports/historyMovement/filter.js": 537,
	"./reports/historyMovement/table": 538,
	"./reports/historyMovement/table.js": 538,
	"./reports/historyMovementBetShop/filter": 539,
	"./reports/historyMovementBetShop/filter.js": 539,
	"./reports/historyMovementBetShop/table": 540,
	"./reports/historyMovementBetShop/table.js": 540,
	"./reports/historyPoints/filter": 541,
	"./reports/historyPoints/filter.js": 541,
	"./reports/historyPoints/table": 542,
	"./reports/historyPoints/table.js": 542,
	"./reports/informeCasino/detailsInformeCasino": 545,
	"./reports/informeCasino/detailsInformeCasino.js": 545,
	"./reports/informeCasino/filterInformeCasino": 543,
	"./reports/informeCasino/filterInformeCasino.js": 543,
	"./reports/informeCasino/recordInformeCasino": 546,
	"./reports/informeCasino/recordInformeCasino.js": 546,
	"./reports/informeCasino/recordTableInformeCasino": 1832,
	"./reports/informeCasino/recordTableInformeCasino.js": 1832,
	"./reports/informeCasino/tableInformeCasino": 544,
	"./reports/informeCasino/tableInformeCasino.js": 544,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome": 441,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome.js": 441,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome": 440,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome.js": 440,
	"./reports/informeGerencial/detailsInformeGerencial": 1833,
	"./reports/informeGerencial/detailsInformeGerencial.js": 1833,
	"./reports/informeGerencial/filterInformeGerencial": 547,
	"./reports/informeGerencial/filterInformeGerencial.js": 547,
	"./reports/informeGerencial/recordInformeGerencial": 1834,
	"./reports/informeGerencial/recordInformeGerencial.js": 1834,
	"./reports/informeGerencial/recordTableInformeGerencial": 30,
	"./reports/informeGerencial/recordTableInformeGerencial.js": 30,
	"./reports/informeGerencial/tableInformeGerencial": 548,
	"./reports/informeGerencial/tableInformeGerencial.js": 548,
	"./reports/informeGerencial2/detailsInformeGerencial": 1835,
	"./reports/informeGerencial2/detailsInformeGerencial.js": 1835,
	"./reports/informeGerencial2/filterInformeGerencial": 1836,
	"./reports/informeGerencial2/filterInformeGerencial.js": 1836,
	"./reports/informeGerencial2/filterInformeGerencial2": 549,
	"./reports/informeGerencial2/filterInformeGerencial2.js": 549,
	"./reports/informeGerencial2/recordInformeGerencial": 1837,
	"./reports/informeGerencial2/recordInformeGerencial.js": 1837,
	"./reports/informeGerencial2/recordTableInformeGerencial": 1838,
	"./reports/informeGerencial2/recordTableInformeGerencial.js": 1838,
	"./reports/informeGerencial2/tableInformeGerencial": 1839,
	"./reports/informeGerencial2/tableInformeGerencial.js": 1839,
	"./reports/informeGerencial2/tableInformeGerencial2": 550,
	"./reports/informeGerencial2/tableInformeGerencial2.js": 550,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial": 1840,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial.js": 1840,
	"./reports/informeGerencialAgentes2/filterInformeGerencial": 1841,
	"./reports/informeGerencialAgentes2/filterInformeGerencial.js": 1841,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2": 551,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2.js": 551,
	"./reports/informeGerencialAgentes2/recordInformeGerencial": 1842,
	"./reports/informeGerencialAgentes2/recordInformeGerencial.js": 1842,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial": 1843,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial.js": 1843,
	"./reports/informeGerencialAgentes2/tableInformeGerencial": 1844,
	"./reports/informeGerencialAgentes2/tableInformeGerencial.js": 1844,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2": 552,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2.js": 552,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial": 1845,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial.js": 1845,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial": 1846,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial.js": 1846,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2": 553,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2.js": 553,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial": 1847,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial.js": 1847,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial": 1848,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial.js": 1848,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial": 1849,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial.js": 1849,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2": 554,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2.js": 554,
	"./reports/jackpotInternationalReport/filter": 555,
	"./reports/jackpotInternationalReport/filter.js": 555,
	"./reports/jackpotInternationalReport/table": 556,
	"./reports/jackpotInternationalReport/table.js": 556,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports": 565,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports.js": 565,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports": 1850,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports.js": 1850,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports": 1851,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports.js": 1851,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports": 566,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports.js": 566,
	"./reports/landingReport/detailsLandingReport": 569,
	"./reports/landingReport/detailsLandingReport.js": 569,
	"./reports/landingReport/filterLandingReport": 567,
	"./reports/landingReport/filterLandingReport.js": 567,
	"./reports/landingReport/recordLandingReport": 570,
	"./reports/landingReport/recordLandingReport.js": 570,
	"./reports/landingReport/recordTableLandingReport": 1852,
	"./reports/landingReport/recordTableLandingReport.js": 1852,
	"./reports/landingReport/tableLandingReport": 568,
	"./reports/landingReport/tableLandingReport.js": 568,
	"./reports/landingReport2/detailsLandingReport": 159,
	"./reports/landingReport2/detailsLandingReport.js": 159,
	"./reports/landingReport2/filterLandingReport": 571,
	"./reports/landingReport2/filterLandingReport.js": 571,
	"./reports/landingReport2/recordLandingReport": 160,
	"./reports/landingReport2/recordLandingReport.js": 160,
	"./reports/landingReport2/recordTableLandingReport": 1853,
	"./reports/landingReport2/recordTableLandingReport.js": 1853,
	"./reports/landingReport2/tableLandingReport": 572,
	"./reports/landingReport2/tableLandingReport.js": 572,
	"./reports/limitationsReport/filterDepositReports": 589,
	"./reports/limitationsReport/filterDepositReports.js": 589,
	"./reports/limitationsReport/tableDepositReports": 590,
	"./reports/limitationsReport/tableDepositReports.js": 590,
	"./reports/logsUser/filter": 593,
	"./reports/logsUser/filter.js": 593,
	"./reports/logsUser/table": 594,
	"./reports/logsUser/table.js": 594,
	"./reports/loteryReport/detailsLoteryReport": 161,
	"./reports/loteryReport/detailsLoteryReport.js": 161,
	"./reports/loteryReport/filterLoteryReport": 595,
	"./reports/loteryReport/filterLoteryReport.js": 595,
	"./reports/loteryReport/recordLoteryReport": 162,
	"./reports/loteryReport/recordLoteryReport.js": 162,
	"./reports/loteryReport/recordTableLoteryReport": 1854,
	"./reports/loteryReport/recordTableLoteryReport.js": 1854,
	"./reports/loteryReport/tableLoteryReport": 48,
	"./reports/loteryReport/tableLoteryReport.js": 48,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 596,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 596,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 597,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 597,
	"./reports/my_comissions_report/filter": 680,
	"./reports/my_comissions_report/filter.js": 680,
	"./reports/my_comissions_report/table": 681,
	"./reports/my_comissions_report/table.js": 681,
	"./reports/notesUser/filter": 682,
	"./reports/notesUser/filter.js": 682,
	"./reports/notesUser/table": 683,
	"./reports/notesUser/table.js": 683,
	"./reports/operatorResponsibility/filter": 684,
	"./reports/operatorResponsibility/filter.js": 684,
	"./reports/operatorResponsibility/table": 685,
	"./reports/operatorResponsibility/table.js": 685,
	"./reports/partners-categories/filter": 822,
	"./reports/partners-categories/filter.js": 822,
	"./reports/partners-categories/table": 823,
	"./reports/partners-categories/table.js": 823,
	"./reports/playersReport/detailsPlayersReport": 851,
	"./reports/playersReport/detailsPlayersReport.js": 851,
	"./reports/playersReport/filterPlayersReport": 849,
	"./reports/playersReport/filterPlayersReport.js": 849,
	"./reports/playersReport/recordPlayersReport": 852,
	"./reports/playersReport/recordPlayersReport.js": 852,
	"./reports/playersReport/recordTablePlayersReport": 853,
	"./reports/playersReport/recordTablePlayersReport.js": 853,
	"./reports/playersReport/tablePlayersReport": 850,
	"./reports/playersReport/tablePlayersReport.js": 850,
	"./reports/pointSettings/filter": 854,
	"./reports/pointSettings/filter.js": 854,
	"./reports/pointSettings/table": 855,
	"./reports/pointSettings/table.js": 855,
	"./reports/pointsUsers/filter": 856,
	"./reports/pointsUsers/filter.js": 856,
	"./reports/pointsUsers/table": 857,
	"./reports/pointsUsers/table.js": 857,
	"./reports/pokerReport/filterCasinoReport": 858,
	"./reports/pokerReport/filterCasinoReport.js": 858,
	"./reports/pokerReport/tableCasinoReport": 859,
	"./reports/pokerReport/tableCasinoReport.js": 859,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1855,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1855,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar": 690,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 690,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1856,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1856,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 926,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 926,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar": 691,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 691,
	"./reports/prizesLoyalty/filter": 860,
	"./reports/prizesLoyalty/filter.js": 860,
	"./reports/prizesLoyalty/table": 861,
	"./reports/prizesLoyalty/table.js": 861,
	"./reports/promotionalCasinoCampaings/filter": 877,
	"./reports/promotionalCasinoCampaings/filter.js": 877,
	"./reports/promotionalCasinoCampaings/table": 878,
	"./reports/promotionalCasinoCampaings/table.js": 878,
	"./reports/promotionalCodes/filter": 879,
	"./reports/promotionalCodes/filter.js": 879,
	"./reports/promotionalCodes/table": 880,
	"./reports/promotionalCodes/table.js": 880,
	"./reports/promotionalSpoortbookCampaings/filter": 881,
	"./reports/promotionalSpoortbookCampaings/filter.js": 881,
	"./reports/promotionalSpoortbookCampaings/table": 882,
	"./reports/promotionalSpoortbookCampaings/table.js": 882,
	"./reports/quotaRetraction/filter": 885,
	"./reports/quotaRetraction/filter.js": 885,
	"./reports/quotaRetraction/table": 886,
	"./reports/quotaRetraction/table.js": 886,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports": 887,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports.js": 887,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports": 1857,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports.js": 1857,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports": 1858,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports.js": 1858,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports": 888,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports.js": 888,
	"./reports/referralsReport/filterReferralsReports": 889,
	"./reports/referralsReport/filterReferralsReports.js": 889,
	"./reports/referralsReport/recordReferralsReports": 1859,
	"./reports/referralsReport/recordReferralsReports.js": 1859,
	"./reports/referralsReport/recordTableReferralsReports": 1860,
	"./reports/referralsReport/recordTableReferralsReports.js": 1860,
	"./reports/referralsReport/tableReferralsReports": 890,
	"./reports/referralsReport/tableReferralsReports.js": 890,
	"./reports/registeredDocuments/filter": 891,
	"./reports/registeredDocuments/filter.js": 891,
	"./reports/registeredDocuments/record": 165,
	"./reports/registeredDocuments/record.js": 165,
	"./reports/registeredDocuments/recordTable": 893,
	"./reports/registeredDocuments/recordTable.js": 893,
	"./reports/registeredDocuments/table": 892,
	"./reports/registeredDocuments/table.js": 892,
	"./reports/relationUserAggregator/filter": 908,
	"./reports/relationUserAggregator/filter.js": 908,
	"./reports/relationUserAggregator/table": 909,
	"./reports/relationUserAggregator/table.js": 909,
	"./reports/reportHash/filter": 910,
	"./reports/reportHash/filter.js": 910,
	"./reports/reportHash/table": 911,
	"./reports/reportHash/table.js": 911,
	"./reports/reportMarketing/filter": 912,
	"./reports/reportMarketing/filter.js": 912,
	"./reports/reportMarketing/table": 913,
	"./reports/reportMarketing/table.js": 913,
	"./reports/rouletteReport/filter": 927,
	"./reports/rouletteReport/filter.js": 927,
	"./reports/rouletteReport/table": 928,
	"./reports/rouletteReport/table.js": 928,
	"./reports/sessionsReport/detailsSessionsReport": 929,
	"./reports/sessionsReport/detailsSessionsReport.js": 929,
	"./reports/sessionsReport/filterSessionsReport": 930,
	"./reports/sessionsReport/filterSessionsReport.js": 930,
	"./reports/sessionsReport/recordSessionsReport": 1046,
	"./reports/sessionsReport/recordSessionsReport.js": 1046,
	"./reports/sessionsReport/recordTableSessionsReport": 1047,
	"./reports/sessionsReport/recordTableSessionsReport.js": 1047,
	"./reports/sessionsReport/tableSessionsReport": 931,
	"./reports/sessionsReport/tableSessionsReport.js": 931,
	"./reports/sessionsReport2/filter": 932,
	"./reports/sessionsReport2/filter.js": 932,
	"./reports/sessionsReport2/table": 933,
	"./reports/sessionsReport2/table.js": 933,
	"./reports/sportsPoolReport/filterReport": 934,
	"./reports/sportsPoolReport/filterReport.js": 934,
	"./reports/sportsPoolReport/tableReport": 935,
	"./reports/sportsPoolReport/tableReport.js": 935,
	"./reports/sportsTransactions/filter": 936,
	"./reports/sportsTransactions/filter.js": 936,
	"./reports/sportsTransactions/table": 937,
	"./reports/sportsTransactions/table.js": 937,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido": 938,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido.js": 938,
	"./reports/summaryBetsReport/filterFlujoCajaResumido": 939,
	"./reports/summaryBetsReport/filterFlujoCajaResumido.js": 939,
	"./reports/summaryBetsReport/recordFlujoCajaResumido": 940,
	"./reports/summaryBetsReport/recordFlujoCajaResumido.js": 940,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido": 1861,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido.js": 1861,
	"./reports/summaryBetsReport/tableFlujoCajaResumido": 941,
	"./reports/summaryBetsReport/tableFlujoCajaResumido.js": 941,
	"./reports/taxPaymentsReport/filter": 942,
	"./reports/taxPaymentsReport/filter.js": 942,
	"./reports/taxPaymentsReport/table": 943,
	"./reports/taxPaymentsReport/table.js": 943,
	"./reports/taxableEarnings/filter": 944,
	"./reports/taxableEarnings/filter.js": 944,
	"./reports/taxableEarnings/table": 945,
	"./reports/taxableEarnings/table.js": 945,
	"./reports/transactionReport/filter": 946,
	"./reports/transactionReport/filter.js": 946,
	"./reports/transactionReport/table": 947,
	"./reports/transactionReport/table.js": 947,
	"./reports/transfersReport/filter": 948,
	"./reports/transfersReport/filter.js": 948,
	"./reports/transfersReport/table": 949,
	"./reports/transfersReport/table.js": 949,
	"./reports/userAffiliatesAgent/filter": 950,
	"./reports/userAffiliatesAgent/filter.js": 950,
	"./reports/userAffiliatesAgent/table": 951,
	"./reports/userAffiliatesAgent/table.js": 951,
	"./reports/userAffiliatesBetShop/filter": 952,
	"./reports/userAffiliatesBetShop/filter.js": 952,
	"./reports/userAffiliatesBetShop/table": 953,
	"./reports/userAffiliatesBetShop/table.js": 953,
	"./reports/usuarioOnlineResumido/filter": 954,
	"./reports/usuarioOnlineResumido/filter.js": 954,
	"./reports/usuarioOnlineResumido/table": 955,
	"./reports/usuarioOnlineResumido/table.js": 955,
	"./reports/withdrawalReport2/filter": 956,
	"./reports/withdrawalReport2/filter.js": 956,
	"./reports/withdrawalReport2/table": 957,
	"./reports/withdrawalReport2/table.js": 957,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests": 958,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 958,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest": 959,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 959,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1862,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1862,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest": 960,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 960,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest": 961,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 961,
	"./reports/withdrawalRequestsComissions/filter": 962,
	"./reports/withdrawalRequestsComissions/filter.js": 962,
	"./reports/withdrawalRequestsComissions/table": 963,
	"./reports/withdrawalRequestsComissions/table.js": 963,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop": 166,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop.js": 166,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop": 964,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop.js": 964,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop": 126,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop.js": 126,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop": 167,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop.js": 167,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop": 965,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop.js": 965,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop": 168,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop.js": 168,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop": 966,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop.js": 966,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop": 1863,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop.js": 1863,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop": 169,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop.js": 169,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop": 967,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop.js": 967,
	"./reprintCheck": 1864,
	"./reprintCheck.js": 1864,
	"./requests/registration-requests/filter": 968,
	"./requests/registration-requests/filter.js": 968,
	"./requests/registration-requests/generateRequests": 969,
	"./requests/registration-requests/generateRequests.js": 969,
	"./requests/registration-requests/recordTableResponts": 970,
	"./requests/registration-requests/recordTableResponts.js": 970,
	"./requests/registration-requests/table": 972,
	"./requests/registration-requests/table.js": 972,
	"./requests/registration-requests/tableResponts": 971,
	"./requests/registration-requests/tableResponts.js": 971,
	"./requests/registrationRequests": 1865,
	"./requests/registrationRequests.js": 1865,
	"./resources-locale_es.json": 1967,
	"./restrictUser": 1866,
	"./restrictUser.js": 1866,
	"./reversionReload": 1867,
	"./reversionReload.js": 1867,
	"./rouletteReport": 1868,
	"./rouletteReport.js": 1868,
	"./security/adminuser/addAdminUser": 1869,
	"./security/adminuser/addAdminUser.js": 1869,
	"./security/adminuser/configuration/changePassword": 1870,
	"./security/adminuser/configuration/changePassword.js": 1870,
	"./security/adminuser/configuration/changePassword/changePasswordView": 973,
	"./security/adminuser/configuration/changePassword/changePasswordView.js": 973,
	"./security/adminuser/configuration/generateToken": 1871,
	"./security/adminuser/configuration/generateToken.js": 1871,
	"./security/adminuser/configuration/generateToken/filter": 974,
	"./security/adminuser/configuration/generateToken/filter.js": 974,
	"./security/adminuser/configuration/generateToken/table": 975,
	"./security/adminuser/configuration/generateToken/table.js": 975,
	"./security/adminuser/configuration/qrgoogle": 1872,
	"./security/adminuser/configuration/qrgoogle.js": 1872,
	"./security/adminuser/configuration/securityChanges": 1873,
	"./security/adminuser/configuration/securityChanges.js": 1873,
	"./security/adminuser/configuration/securityChanges/filter": 172,
	"./security/adminuser/configuration/securityChanges/filter.js": 172,
	"./security/adminuser/configuration/securityChanges/table": 130,
	"./security/adminuser/configuration/securityChanges/table.js": 130,
	"./security/adminuser/configurationAdminUser": 1874,
	"./security/adminuser/configurationAdminUser.js": 1874,
	"./security/adminuser/detailsAdminUser": 1875,
	"./security/adminuser/detailsAdminUser.js": 1875,
	"./security/adminuser/filterAdminUser": 209,
	"./security/adminuser/filterAdminUser.js": 209,
	"./security/adminuser/informationAdminUser": 1876,
	"./security/adminuser/informationAdminUser.js": 1876,
	"./security/adminuser/recordAdminUser": 1877,
	"./security/adminuser/recordAdminUser.js": 1877,
	"./security/adminuser/recordTableAdminUser": 976,
	"./security/adminuser/recordTableAdminUser.js": 976,
	"./security/adminuser/reports/logsUser": 1878,
	"./security/adminuser/reports/logsUser.js": 1878,
	"./security/adminuser/reports/logsUser/filter": 977,
	"./security/adminuser/reports/logsUser/filter.js": 977,
	"./security/adminuser/reports/logsUser/table": 978,
	"./security/adminuser/reports/logsUser/table.js": 978,
	"./security/adminuser/reportsAdminUser": 1879,
	"./security/adminuser/reportsAdminUser.js": 1879,
	"./security/adminuser/tableAdminUser": 210,
	"./security/adminuser/tableAdminUser.js": 210,
	"./security/approvalLogs/filter": 288,
	"./security/approvalLogs/filter.js": 288,
	"./security/approvalLogs/table": 289,
	"./security/approvalLogs/table.js": 289,
	"./security/approvalLogs2/filter": 290,
	"./security/approvalLogs2/filter.js": 290,
	"./security/approvalLogs2/table": 291,
	"./security/approvalLogs2/table.js": 291,
	"./security/approvalLogsBetShop/filter": 292,
	"./security/approvalLogsBetShop/filter.js": 292,
	"./security/approvalLogsBetShop/table": 293,
	"./security/approvalLogsBetShop/table.js": 293,
	"./security/contingencia/detailsContingencia": 1880,
	"./security/contingencia/detailsContingencia.js": 1880,
	"./security/contingencia/filterContingencia": 446,
	"./security/contingencia/filterContingencia.js": 446,
	"./security/contingencia/recordContingencia": 1881,
	"./security/contingencia/recordContingencia.js": 1881,
	"./security/contingencia/recordTableContingencia": 979,
	"./security/contingencia/recordTableContingencia.js": 979,
	"./security/contingencia/tableContingencia": 447,
	"./security/contingencia/tableContingencia.js": 447,
	"./security/menu/filter": 670,
	"./security/menu/filter.js": 670,
	"./security/menu/table": 671,
	"./security/menu/table.js": 671,
	"./security/perfil/detailsPerfil": 874,
	"./security/perfil/detailsPerfil.js": 874,
	"./security/perfil/filterPerfil": 872,
	"./security/perfil/filterPerfil.js": 872,
	"./security/perfil/recordPerfil": 875,
	"./security/perfil/recordPerfil.js": 875,
	"./security/perfil/recordTablePerfil": 876,
	"./security/perfil/recordTablePerfil.js": 876,
	"./security/perfil/tablePerfil": 873,
	"./security/perfil/tablePerfil.js": 873,
	"./security/perfilopciones/detailsPerfilOpciones": 124,
	"./security/perfilopciones/detailsPerfilOpciones.js": 124,
	"./security/perfilopciones/filterPerfilOpciones": 86,
	"./security/perfilopciones/filterPerfilOpciones.js": 86,
	"./security/perfilopciones/permissionsTree": 164,
	"./security/perfilopciones/permissionsTree.js": 164,
	"./security/perfilopciones/recordPerfilOpciones": 125,
	"./security/perfilopciones/recordPerfilOpciones.js": 125,
	"./security/perfilopciones/recordTablePerfilOpciones": 66,
	"./security/perfilopciones/recordTablePerfilOpciones.js": 66,
	"./security/perfilopciones/tablePerfilOpciones": 65,
	"./security/perfilopciones/tablePerfilOpciones.js": 65,
	"./security/perfilopciones2/detailsPerfilOpciones": 1882,
	"./security/perfilopciones2/detailsPerfilOpciones.js": 1882,
	"./security/perfilopciones2/filterPerfilOpciones": 1883,
	"./security/perfilopciones2/filterPerfilOpciones.js": 1883,
	"./security/perfilopciones2/recordPerfilOpciones": 1884,
	"./security/perfilopciones2/recordPerfilOpciones.js": 1884,
	"./security/perfilopciones2/recordTablePerfilOpciones": 1885,
	"./security/perfilopciones2/recordTablePerfilOpciones.js": 1885,
	"./security/perfilopciones2/tablePerfilOpciones": 1886,
	"./security/perfilopciones2/tablePerfilOpciones.js": 1886,
	"./security/perfilopcionesOld/detailsPerfilOpciones": 1887,
	"./security/perfilopcionesOld/detailsPerfilOpciones.js": 1887,
	"./security/perfilopcionesOld/filterPerfilOpciones": 1888,
	"./security/perfilopcionesOld/filterPerfilOpciones.js": 1888,
	"./security/perfilopcionesOld/recordPerfilOpciones": 1889,
	"./security/perfilopcionesOld/recordPerfilOpciones.js": 1889,
	"./security/perfilopcionesOld/recordTablePerfilOpciones": 1890,
	"./security/perfilopcionesOld/recordTablePerfilOpciones.js": 1890,
	"./security/perfilopcionesOld/tablePerfilOpciones": 1891,
	"./security/perfilopcionesOld/tablePerfilOpciones.js": 1891,
	"./security/submenu/detailsSubMenu": 980,
	"./security/submenu/detailsSubMenu.js": 980,
	"./security/submenu/filterSubMenu": 981,
	"./security/submenu/filterSubMenu.js": 981,
	"./security/submenu/recordSubMenu": 982,
	"./security/submenu/recordSubMenu.js": 982,
	"./security/submenu/recordTableSubMenu": 983,
	"./security/submenu/recordTableSubMenu.js": 983,
	"./security/submenu/tableSubMenu": 984,
	"./security/submenu/tableSubMenu.js": 984,
	"./security/totalContingencies/table": 985,
	"./security/totalContingencies/table.js": 985,
	"./security/userSitebuilder/filter": 986,
	"./security/userSitebuilder/filter.js": 986,
	"./security/userSitebuilder/information": 1892,
	"./security/userSitebuilder/information.js": 1892,
	"./security/userSitebuilder/table": 987,
	"./security/userSitebuilder/table.js": 987,
	"./security/userVerification2/filter": 988,
	"./security/userVerification2/filter.js": 988,
	"./security/userVerification2/information": 1893,
	"./security/userVerification2/information.js": 1893,
	"./security/userVerification2/table": 989,
	"./security/userVerification2/table.js": 989,
	"./security/usuarioperfil/detailsUsuarioPerfil": 1894,
	"./security/usuarioperfil/detailsUsuarioPerfil.js": 1894,
	"./security/usuarioperfil/filterUsuarioPerfil": 990,
	"./security/usuarioperfil/filterUsuarioPerfil.js": 990,
	"./security/usuarioperfil/recordTableUsuarioPerfil": 991,
	"./security/usuarioperfil/recordTableUsuarioPerfil.js": 991,
	"./security/usuarioperfil/recordUsuarioPerfil": 1895,
	"./security/usuarioperfil/recordUsuarioPerfil.js": 1895,
	"./security/usuarioperfil/tableUsuarioPerfil": 992,
	"./security/usuarioperfil/tableUsuarioPerfil.js": 992,
	"./security/usuariosbloqueados/add": 1896,
	"./security/usuariosbloqueados/add.js": 1896,
	"./security/usuariosbloqueados/filter": 993,
	"./security/usuariosbloqueados/filter.js": 993,
	"./security/usuariosbloqueados/table": 994,
	"./security/usuariosbloqueados/table.js": 994,
	"./security/wallets/filter": 995,
	"./security/wallets/filter.js": 995,
	"./security/wallets/table": 996,
	"./security/wallets/table.js": 996,
	"./sessionsReport": 1897,
	"./sessionsReport.js": 1897,
	"./sessionsReport2": 1898,
	"./sessionsReport2.js": 1898,
	"./settings": 1899,
	"./settings.js": 1899,
	"./significantEventsAndAlterations": 1900,
	"./significantEventsAndAlterations.js": 1900,
	"./significantEventsAndAlterations2": 1901,
	"./significantEventsAndAlterations2.js": 1901,
	"./sportsPoolReport": 1902,
	"./sportsPoolReport.js": 1902,
	"./sportsTransactions": 1903,
	"./sportsTransactions.js": 1903,
	"./subMenu": 1904,
	"./subMenu.js": 1904,
	"./subProviders": 1905,
	"./subProviders.js": 1905,
	"./summaryBetsReport": 1906,
	"./summaryBetsReport.js": 1906,
	"./summaryCashFlow": 1907,
	"./summaryCashFlow.js": 1907,
	"./summaryCashFlow2": 1908,
	"./summaryCashFlow2.js": 1908,
	"./summaryCashFlowMachine": 1909,
	"./summaryCashFlowMachine.js": 1909,
	"./tags": 1910,
	"./tags.js": 1910,
	"./taxPaymentsReport": 1911,
	"./taxPaymentsReport.js": 1911,
	"./taxableEarnings": 1912,
	"./taxableEarnings.js": 1912,
	"./teacher/concessionaire/filterConcessionaire": 522,
	"./teacher/concessionaire/filterConcessionaire.js": 522,
	"./teacher/concessionaire/tableConcessionaire": 523,
	"./teacher/concessionaire/tableConcessionaire.js": 523,
	"./teacher/qualifying/filterQualifying": 883,
	"./teacher/qualifying/filterQualifying.js": 883,
	"./teacher/qualifying/tableQualifying": 884,
	"./teacher/qualifying/tableQualifying.js": 884,
	"./teacher/registered-documents/filterRegisteredDocuments": 894,
	"./teacher/registered-documents/filterRegisteredDocuments.js": 894,
	"./teacher/registered-documents/tableRegisteredDocuments": 895,
	"./teacher/registered-documents/tableRegisteredDocuments.js": 895,
	"./termsAndConditions": 1913,
	"./termsAndConditions.js": 1913,
	"./toolbar": 12,
	"./toolbar.js": 12,
	"./tools/countries/filter": 448,
	"./tools/countries/filter.js": 448,
	"./tools/countries/table": 449,
	"./tools/countries/table.js": 449,
	"./tools/currencyManagement/currencyFilters": 173,
	"./tools/currencyManagement/currencyFilters.js": 173,
	"./tools/currencyManagement/currencyTable": 174,
	"./tools/currencyManagement/currencyTable.js": 174,
	"./tools/translationManager": 1914,
	"./tools/translationManager.js": 1914,
	"./tools/translationManager/filter": 997,
	"./tools/translationManager/filter.js": 997,
	"./tools/translationManager/table": 998,
	"./tools/translationManager/table.js": 998,
	"./tools/uploadImage": 1915,
	"./tools/uploadImage.js": 1915,
	"./top": 1916,
	"./top.js": 1916,
	"./totalContingencies": 1917,
	"./totalContingencies.js": 1917,
	"./transactionReport": 1918,
	"./transactionReport.js": 1918,
	"./transactions": 1919,
	"./transactions.js": 1919,
	"./transactionsByPlayer": 1920,
	"./transactionsByPlayer.js": 1920,
	"./transactionsByPlayerDeposit": 1921,
	"./transactionsByPlayerDeposit.js": 1921,
	"./transactionsByPlayerFirstLevel": 1922,
	"./transactionsByPlayerFirstLevel.js": 1922,
	"./transactionsByPlayerSecondLevel": 1923,
	"./transactionsByPlayerSecondLevel.js": 1923,
	"./trasnfersReport": 1924,
	"./trasnfersReport.js": 1924,
	"./tutorials": 1925,
	"./tutorials.js": 1925,
	"./userAffiliatesAgent": 1926,
	"./userAffiliatesAgent.js": 1926,
	"./userAffiliatesBetShop": 1927,
	"./userAffiliatesBetShop.js": 1927,
	"./userManagement": 1928,
	"./userManagement.js": 1928,
	"./userManagement/userManagement/detailsUserManagement": 1001,
	"./userManagement/userManagement/detailsUserManagement.js": 1001,
	"./userManagement/userManagement/filterUserManagement": 999,
	"./userManagement/userManagement/filterUserManagement.js": 999,
	"./userManagement/userManagement/recordTableUserManagement": 1003,
	"./userManagement/userManagement/recordTableUserManagement.js": 1003,
	"./userManagement/userManagement/recordUserManagement": 1002,
	"./userManagement/userManagement/recordUserManagement.js": 1002,
	"./userManagement/userManagement/tableUserManagement": 1000,
	"./userManagement/userManagement/tableUserManagement.js": 1000,
	"./userProfile": 1929,
	"./userProfile.js": 1929,
	"./usersSitebuilder": 1930,
	"./usersSitebuilder.js": 1930,
	"./usersVerification": 1931,
	"./usersVerification.js": 1931,
	"./usersVerification/information": 1004,
	"./usersVerification/information.js": 1004,
	"./usersVerification2": 1932,
	"./usersVerification2.js": 1932,
	"./usersVerificationManagement": 1933,
	"./usersVerificationManagement.js": 1933,
	"./usuarioOnlineResumido": 1934,
	"./usuarioOnlineResumido.js": 1934,
	"./usuariosbloqueados": 1935,
	"./usuariosbloqueados.js": 1935,
	"./verifyAccount": 1936,
	"./verifyAccount.js": 1936,
	"./verifyAccountAgent": 1937,
	"./verifyAccountAgent.js": 1937,
	"./verifyAccountJumio": 1938,
	"./verifyAccountJumio.js": 1938,
	"./wallets": 1939,
	"./wallets.js": 1939,
	"./watchListReport": 1940,
	"./watchListReport.js": 1940,
	"./watchListReport/filterReport": 1005,
	"./watchListReport/filterReport.js": 1005,
	"./watchListReport/tableReport": 1006,
	"./watchListReport/tableReport.js": 1006,
	"./widgets": 1941,
	"./widgets.js": 1941,
	"./withdrawal": 1942,
	"./withdrawal.js": 1942,
	"./withdrawalReport2": 1943,
	"./withdrawalReport2.js": 1943,
	"./withdrawalRequests": 1944,
	"./withdrawalRequests.js": 1944,
	"./withdrawalRequestsBetShop": 1945,
	"./withdrawalRequestsBetShop.js": 1945,
	"./withdrawalRequestsComissions": 1946,
	"./withdrawalRequestsComissions.js": 1946,
	"./withdrawalRequestsForBetShop": 1947,
	"./withdrawalRequestsForBetShop.js": 1947,
	"./withdrawalRequestsForBetShop2": 1948,
	"./withdrawalRequestsForBetShop2.js": 1948,
	"./withdrawalRequestsRetail": 1949,
	"./withdrawalRequestsRetail.js": 1949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1959;